function cstrapKhoiTao(SID, CFG) {
    var root = document.getElementById('cstrap-' + SID + '');
    if (!root) return;

    /* 21/09 builder: Curved End doi tu <select> sang tile radio (nhu bai san v2 18/09). Engine khap noi doc `.value`, `.options[i].value`,
       `addEventListener('change')`, `dispatchEvent`, `removeAttribute('name')` cua select -> boc nhom radio thanh mot vat the cung mat
       ngoai (chep nguyen tu cstrap-engine-v2.js). Tim theo name truoc; thang gia go `name` nen co them duong `data-*` tren .cfield. */
    function radioNhuSelect(ten, attr) {
      var ds = root.querySelectorAll('input[type="radio"][name="properties[' + ten + ']"]');
      if (!ds.length && attr) ds = root.querySelectorAll('[' + attr + '] input[type="radio"]');
      if (!ds.length) return null;
      var arr = Array.prototype.slice.call(ds);
      return {
        laRadio: true, radios: arr, tagName: 'RADIOS', id: (arr[0].closest('.cfield') || {}).id || '',
        get value() { for (var i = 0; i < arr.length; i++) if (arr[i].checked) return arr[i].value; return ''; },
        set value(v) { for (var i = 0; i < arr.length; i++) arr[i].checked = (arr[i].value === v); },
        get options() { return arr.map(function (r) { return { value: r.value, textContent: r.value, disabled: r.disabled }; }); },
        get disabled() { return arr[0].disabled; }, set disabled(v) { arr.forEach(function (r) { r.disabled = !!v; }); },
        addEventListener: function (t, f, o) { arr.forEach(function (r) { r.addEventListener(t, f, o); }); },
        dispatchEvent: function (ev) { var c = arr.filter(function (r) { return r.checked; })[0] || arr[0]; return c.dispatchEvent(ev); },
        /* Thang gia goi removeAttribute('name') de property khong di vao don. Radio ma mat `name` la MAT NHOM
           (No va Yes cung tick duoc). Doi sang ten ngoai properties[...] — /cart/add bo qua tham so la — nhom giu nguyen. */
        removeAttribute: function (a) {
          if (a === 'name') { arr.forEach(function (r) { r.name = '_' + ten.toLowerCase().replace(/[^a-z0-9]+/g, '-'); }); return; }
          arr.forEach(function (r) { r.removeAttribute(a); });
        },
        setAttribute: function (a, v) { arr.forEach(function (r) { r.setAttribute(a, v); }); },
        closest: function (sel) { return arr[0].closest(sel); },
        contains: function (el) { return arr.indexOf(el) >= 0; }
      };
    }

    /* Photo carousel = native horizontal scroll-snap track (smooth drag, no JS physics). Thumbnails
       scroll it; the slide that lands under the viewport drives the active thumb and the zoom index. */
    var track = root.querySelector('[data-cstrap-track]');
    var slides = root.querySelectorAll('.cstrap__slide');
    var mainImgs = root.querySelectorAll('.cstrap__mainimg');
    // phan thua tu cuon trong rail. Chi ap rail DOC (desktop nopv).
    (function () {
      var mw = root.querySelector('.cstrap__mainwrap');
      var rl = root.querySelector('.cstrap__thumbs');
      if (!mw || !rl) return;
      function canRail() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          rl.style.maxHeight = Math.round(mw.getBoundingClientRect().height) + 'px';
        } else {
          rl.style.maxHeight = '';
        }
      }
      canRail();
      window.addEventListener('resize', canRail);
      if (mainImgs[0]) mainImgs[0].addEventListener('load', canRail, { once: true });
    })();
    var choNangCap = [];
    mainImgs.forEach(function (im) { if (im.hasAttribute('data-srcset')) choNangCap.push(im); });

    function nangCap(im) {
      if (!im || !im.hasAttribute('data-srcset')) return;
      var ss = im.getAttribute('data-srcset');
      var sz = im.getAttribute('data-sizes');
      im.removeAttribute('data-srcset');
      im.removeAttribute('data-sizes');
      im.classList.add('cho-tai');
      im.addEventListener('load', function () {
        im.classList.remove('cho-tai'); im.classList.add('da-tai');
      }, { once: true });
      im.addEventListener('error', function () { im.classList.remove('cho-tai'); }, { once: true });
      if (sz) im.setAttribute('sizes', sz);
      im.setAttribute('srcset', ss);
    }

    var theoDoi = null;
    if (track && 'IntersectionObserver' in window) {
      theoDoi = new IntersectionObserver(function (mucs) {
        mucs.forEach(function (mu) {
          if (!mu.isIntersecting) return;
          nangCap(mu.target);
          theoDoi.unobserve(mu.target);
        });
      }, { root: track, rootMargin: '0px 120% 0px 120%', threshold: 0 });
    }
    function quanSat(im) {
      if (!im || !im.hasAttribute('data-srcset')) return;
      if (theoDoi) theoDoi.observe(im); else nangCap(im);
    }
    choNangCap.forEach(quanSat);

    // Blur-up cho anh gallery (spec delugs): anh lazy chua ve = blur 5px, ve xong
    // chuyen net .2s — khong bao gio thay o trang trong khung.
    // bang rule CSS `[data-srcset]`; gan them `cho-tai` o day se go mo sai luc.
    mainImgs.forEach(function (im) {
      if (im.hasAttribute('data-srcset')) return;
      if (im.complete && im.naturalWidth > 0) return;
      im.classList.add('cho-tai');
      im.addEventListener('load', function () {
        im.classList.remove('cho-tai'); im.classList.add('da-tai');
      }, { once: true });
      im.addEventListener('error', function () { im.classList.remove('cho-tai'); }, { once: true });
    });
    var mainImg = mainImgs[0];
    // 16/09 (chieu): BO HAN co che nap tre rieng cho chip khoa/kieu chi/spring bar.
    // Thu nghiem 15/09 dung `data-lazy-src` + IntersectionObserver de hoan tai 18 anh nay,
    // nhung chip nam trong luoi cuon ngang nen o nao troi sang phai thi khong cat khung nhin
    // -> khach nhin thay o trang. 18 anh nay moi anh ~3 KB o ban width=240; tai thang re hon
    // nhieu so voi cai gia phai tra. Nay chung dung `src` that + loading="lazy" trong HTML,
    // y het nhom Style of Strap / Tip Shape (snippets/cstrap-shape.liquid) von chay dung.
    var thumbs = root.querySelectorAll('.cstrap__thumb');
    var galleryIdx = 0;
    function setGalleryIdx(n) {
      galleryIdx = n;
      thumbs.forEach(function (x, xi) { x.classList.toggle('is-active', xi === n); });
      /* Khung dang la video thi khong co gi de phong to — cat nut zoom di, khong
         thi no mo nham anh. Dung .style chu khong dung `hidden`, vi nut nay co
         rule display co san se de len [hidden]. */
      var slAct = slides[n];
      var zbAct = root.querySelector('.cstrap__zoom');
      if (zbAct) zbAct.style.display = (slAct && slAct.getAttribute('data-anh') === '-1')
        ? 'none' : '';
      /* Cuon sang khung khac ma video con chay thi tieng chay ngam sau anh. */
      slides.forEach(function (s, si) {
        if (si === n) return;
        var v = s.querySelector('video');
        if (v && !v.paused) v.pause();
      });
      // Auto-center thumb active (spec delugs buoc 5) — rail doc lan ngang deu can giua.
      var tAct = thumbs[n];
      if (tAct && tAct.offsetParent !== null) {
        var rail = tAct.closest('.cstrap__thumbs');
        if (rail) requestAnimationFrame(function () {
          // Tru offset cua chinh rail: offsetTop cua thumb tinh theo to tien positioned
          rail.scrollTo({
            top: tAct.offsetTop - rail.offsetTop - rail.clientHeight / 2 + tAct.clientHeight / 2,
            left: tAct.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + tAct.clientWidth / 2,
            behavior: 'smooth'
          });
        });
      }
    }
    if (track && slides.length) {
      var N = slides.length;
      var vong = N > 1;
      if (vong) {
        var clCuoi = slides[N - 1].cloneNode(true);
        var clDau = slides[0].cloneNode(true);
        /* Ban sao de cuon vong: trung o video thi se co HAI trinh phat cung mot
           video trong DOM — bam ban sao la phat chong len ban that. Thay bang
           anh poster: nhin y het, khong phat duoc. */
        [clCuoi, clDau].forEach(function (c) {
          c.querySelectorAll('video').forEach(function (v) {
            var anh = document.createElement('img');
            anh.src = v.getAttribute('poster') || '';
            anh.className = 'cstrap__mainimg';
            anh.alt = '';
            v.parentNode.replaceChild(anh, v);
          });
        });
        [clCuoi, clDau].forEach(function (c) {
          c.querySelectorAll('img').forEach(function (im) {
            im.classList.remove('cho-tai'); im.classList.remove('da-tai');
            im.loading = 'eager';
            quanSat(im);
          });
        });
        track.insertBefore(clCuoi, slides[0]);
        track.appendChild(clDau);
        requestAnimationFrame(function () { track.scrollLeft = track.clientWidth; });
      }
      function rawSangLogic(raw) { return vong ? ((raw - 1 + N) % N) : raw; }
      function cuonToiLogic(i, tucThoi) {
        var raw = vong ? i + 1 : i;
        track.scrollTo({ left: raw * track.clientWidth, behavior: tucThoi ? 'auto' : 'smooth' });
      }
      function teleportNeuClone() {
        if (!vong || _down) return;
        var w = track.clientWidth;
        var raw = Math.round(track.scrollLeft / w);
        if (raw !== 0 && raw !== N + 1) return;
        var snapCu = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = (raw === 0 ? N : 1) * w;
        void track.offsetWidth;
        track.style.scrollSnapType = snapCu || '';
      }
      window.addEventListener('resize', function () { cuonToiLogic(galleryIdx, true); });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { cuonToiLogic(i); });
      });
      var _sc;
      track.addEventListener('scroll', function () {
        clearTimeout(_sc);
        _sc = setTimeout(function () {
          teleportNeuClone();
          var lg = rawSangLogic(Math.round(track.scrollLeft / track.clientWidth));
          if (lg !== galleryIdx) setGalleryIdx(lg);
        }, 60);
      }, { passive: true });

      /* Desktop: drag the carousel with the mouse (touch scrolls natively). Snap is off while
         dragging so it follows the cursor, then restored so it settles on the nearest photo; a real
         drag suppresses the click so it does not also open the zoom. */
      var _down = false, _sx = 0, _sl = 0, _dragged = false, _lx = 0, _lt = 0, _v = 0, _snapT = null;
      track.addEventListener('mousedown', function (e) {
        _down = true; _dragged = false; _sx = e.pageX; _sl = track.scrollLeft;
        _lx = e.pageX; _lt = performance.now(); _v = 0;
        if (_snapT) { clearTimeout(_snapT); _snapT = null; }
        track.style.scrollSnapType = 'none'; track.style.cursor = 'grabbing';
      });
      window.addEventListener('mousemove', function (e) {
        if (!_down) return;
        var dx = e.pageX - _sx;
        if (Math.abs(dx) > 4) _dragged = true;
        var luc = performance.now();
        _v = (e.pageX - _lx) / Math.max(1, luc - _lt);
        _lx = e.pageX; _lt = luc;
        track.scrollLeft = _sl - dx;
      });
      window.addEventListener('mouseup', function (e) {
        if (!_down) return;
        _down = false; track.style.cursor = '';
        var dx = _lx - _sx;
        var cu = Math.round(_sl / track.clientWidth);
        var dich = Math.round(track.scrollLeft / track.clientWidth);
        if (dich === cu && (Math.abs(dx) > 80 || (Math.abs(dx) > 25 && Math.abs(_v) > 0.35))) {
          dich = cu + (dx < 0 ? 1 : -1);
        }
        // Vong 360: cho phep dap len CLONE o 2 dau (raw 0 / N+1) — settle se teleport.
        dich = Math.max(0, Math.min(vong ? N + 1 : N - 1, dich));
        track.scrollTo({ left: dich * track.clientWidth, behavior: 'smooth' });
        _snapT = setTimeout(function () { track.style.scrollSnapType = ''; _snapT = null; }, 380);
      });
      track.addEventListener('click', function (e) {
        if (_dragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* Edge arrows step one photo. */
      var prevBtn = root.querySelector('[data-cstrap-prev]');
      var nextBtn = root.querySelector('[data-cstrap-next]');
      function goSlide(step) {
        // wrapAround 360: buoc theo RAW (ke ca len clone) — truot dung MOT buoc muot
        var raw = Math.round(track.scrollLeft / track.clientWidth) + step;
        raw = Math.max(0, Math.min(vong ? N + 1 : N - 1, raw));
        track.scrollTo({ left: raw * track.clientWidth, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { goSlide(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goSlide(1); });

      var daWarm = false;
      // P2 (2026-09-15): 6 x 1200w (~600 KB) tung tai NGAY khi re vao gallery va chia bang thong voi
      // anh tier cua lightbox (do: click->net 2 s thay vi 0,5 s). Gio cho 400 ms (re luot qua thi
      // thoi) va nhuong khi tier dang tai (root.__tierBusy do napAnh dat).
      var warmGallery = function () {
        if (daWarm) return;
        if (root.__tierBusy) { setTimeout(warmGallery, 250); return; }
        daWarm = true;
        thumbs.forEach(function (t) { if (t.dataset.full) { var im = new Image(); im.fetchPriority = 'low'; im.src = t.dataset.full; } });
      };
      var warmGalleryCho = function () { setTimeout(warmGallery, 400); };
      var moiWarm = { once: true, passive: true };
      if (track) {
        track.addEventListener('pointerdown', warmGalleryCho, moiWarm);
        track.addEventListener('pointerenter', warmGalleryCho, moiWarm);
        track.addEventListener('touchstart', warmGalleryCho, moiWarm);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('pointerenter', warmGalleryCho, moiWarm);
        t.addEventListener('pointerdown', warmGalleryCho, moiWarm);
      });
      var nutZoom = root.querySelector('.cstrap__zoom');
      if (nutZoom) nutZoom.addEventListener('pointerdown', warmGalleryCho, moiWarm);
    }

    /*
      Product photo viewer. The photo list comes from the JSON block beside the gallery rather
      than from the thumbnail strip, because the strip is capped at eight and hidden entirely
      when a product has one photograph.
    */
    (function () {
      var plb = document.getElementById('cphoto-lb-' + SID + '');
      var src = root.querySelector('.cstrap__photos');
      if (!plb || !src || !mainImg) return;

      var photos = [];
      try { photos = JSON.parse(src.textContent) || []; } catch (e) { photos = []; }
      if (!photos.length) return;

      /* Out of the section, so a transformed ancestor cannot capture position: fixed. */
      document.body.appendChild(plb);
      // A11y (spec delugs buoc 10): dialog modal; focus tra ve nut mo khi dong.
      plb.setAttribute('role', 'dialog');
      plb.setAttribute('aria-modal', 'true');
      plb.setAttribute('aria-label', 'Product photos');

      var stage = plb.querySelector('.cphoto-lb__stage');
      var track = plb.querySelector('.cphoto-lb__track');
      var pcount = plb.querySelector('.cphoto-lb__counter');
      var i = 0;
      var cells = photos.map(function (p) {
        var cell = document.createElement('div'); cell.className = 'cphoto-lb__cell';
        var im = document.createElement('img');
        im.alt = p.alt || ''; im.draggable = false; im.decoding = 'async';
        cell.appendChild(im); track.appendChild(cell);
        return im;
      });
      function pimg() { return cells[i]; }
      var cellW = 0, GAP = 0;   // gap 0: cell ghep sat (dong bo voi CSS gap 0)
      function doCell() {
        // bat ky diem nao tren man (track phu het).
        stage.style.width = '';
        cellW = Math.max(200, stage.clientWidth);
        cells.forEach(function (c) { c.parentElement.style.width = cellW + 'px'; });
      }
      function datTrack(dx) {
        var goc = (stage.clientWidth - cellW) / 2 - i * (cellW + GAP);
        track.style.transform = 'translateX(' + (goc + (dx || 0)) + 'px)';
      }
      window.addEventListener('resize', function () {
        if (plb.hidden) return;
        doCell(); datTrack(0);
      });

      /* Zoom + pan state. Every new image starts fit-to-screen (resetZoom in paint). */
      var LA_MOBILE = window.matchMedia('(max-width: 749px)').matches;
      var zoom = 1, panX = 0, panY = 0, ZOOM = LA_MOBILE ? 2 : 2.6;
      /* Tier theo VIEWPORT chu khong theo pixel vat ly: iPhone dpr3 co
          844x3=2532 pixel vat ly, cong thuc cu xep nham vao nhom man lon va tai 3000px
          (do 2026-08-18). Phone 1600 la du cho pinch 5x. */
      var TIER = LA_MOBILE ? 1600 : 3000;
      /* P3/B5 (2026-09-15): mobile mo lightbox van 1600 (nhe, ~100 KB), nhung tap 2x can 2340 px
         (390 css x dpr 3 x 2) — vua bat dau zoom thi nang anh dang xem len 2400 (~+100 KB), khach
         khong zoom thi khong ton. Desktop 3000 da du cho 2,6x (2340). */
      var TIER_ZOOM = LA_MOBILE ? 2400 : 3000;
      var _dangNap = {};
      function urlTier(u, w) { return u.replace(/([?&]width=)\d+/, '$1' + w); }
      /* Tier can cho anh k o trang thai hien tai: dang zoom (hoac sap zoom) -> TIER_ZOOM, nhung
         goc <= TIER thi TIER_ZOOM cung chi tra ve goc (1254) — khong xin them. */
      function tierCan(k, zoomTrangThai) {
        if (!zoomTrangThai || TIER_ZOOM === TIER) return TIER;
        if (photos[k] && photos[k].w && photos[k].w <= TIER) return TIER;
        return TIER_ZOOM;
      }
      function napTierZoom() { napAnh(i, 'high', tierCan(i, true)); }
      function visKich() {
        var el = pimg();
        var bw = el.offsetWidth, bh = el.offsetHeight;
        var nw = el.naturalWidth || bw, nh = el.naturalHeight || bh;
        if (!nw || !nh) return { w: bw, h: bh };
        var ty = Math.min(bw / nw, bh / nh);
        return { w: nw * ty, h: nh * ty };
      }
      function applyT() {
        pimg().style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
      }
      var visCache = null;
      function clampPan() {
        var v = visCache || visKich();
        var ov = v.w * (zoom - 1) / 2;
        var oh = v.h * (zoom - 1) / 2;
        panX = Math.max(-ov, Math.min(ov, panX));
        panY = Math.max(-oh, Math.min(oh, panY));
      }
      function resetZoom() {
        zoom = 1; panX = 0; panY = 0;
        visCache = null;
        cells.forEach(function (c) { c.style.transform = ''; });
        plb.classList.remove('is-zoomed');
      }

      var _xongTier = [];   // callback cho "tier anh dang xem da xong" (anh ke doi cai nay)
      var _uuTien = {};
      function napAnh(k, uuTien, tierMuon) {
        var t = tierMuon || TIER;
        var im = cells[k];
        if (!im || parseInt(im.getAttribute('data-t'), 10) >= t) return;
        var to = urlTier(photos[k].src, t);
        if (!im.getAttribute('src')) {
          // Anh chua nang cap thi currentSrc la ban 32px — phong len toan man se ro hat,
          // te hon la tai thang ban 1200.
          var gal = mainImgs[k];
          var dungLai = gal && !gal.hasAttribute('data-srcset') && gal.currentSrc;
          var srcDau = dungLai ? gal.currentSrc : urlTier(photos[k].src, 1200);
          // P2/B2 (2026-09-15): placeholder la anh gallery da co san (900w desktop / 1200w mobile)
          // — rong >= khung ve (min(vw,vh) x dpr) thi no DA net 1:1: hien ngay khong blur, tier
          // nang ngam. Chi blur-up khi placeholder thieu pixel (thumb 32px, man 2K...).
          var wDau = parseInt((/[?&]width=(\d+)/.exec(srcDau) || [])[1], 10) || 0;
          var canPx = Math.ceil(Math.min(window.innerWidth, window.innerHeight) * (window.devicePixelRatio || 1));
          if (!(dungLai && wDau >= canPx)) im.classList.add('cho-tai');
          im.src = srcDau;
        }
        if (_dangNap[k] === to) {
          // P5: dang bay o hang THAP (nap truoc lam anh ke) ma gio khach toi -> xin lai cung URL
          // hang CAO; Chrome nang uu tien request dang bay cho cung URL, khong tai them lan hai.
          if (uuTien === 'high' && _uuTien[k] !== 'high') { _uuTien[k] = 'high'; var l2 = new Image(); l2.fetchPriority = 'high'; l2.src = to; }
          return;
        }
        _dangNap[k] = to; _uuTien[k] = uuTien || 'low';
        var lon = new Image();
        // Anh dang xem xin hang CAO: new Image() khong gan DOM mac dinh bi Chrome xep Low,
        // thua ca prefetch checkout/Judge.me dang chay nen (do P1 15/09: 0,75-3,2 s tren 4G).
        lon.fetchPriority = uuTien || 'low';
        var cao = uuTien === 'high';
        if (cao) root.__tierBusy = (root.__tierBusy || 0) + 1;
        var xong = function () { if (cao) { root.__tierBusy = Math.max(0, (root.__tierBusy || 0) - 1); } _xongTier.splice(0).forEach(function (f) { f(); }); chayHang(); };
        lon.onload = function () {
          // Khong ha tier: 1600 ve sau khi 2400 da len thi bo qua.
          if (!(parseInt(im.getAttribute('data-t'), 10) >= t)) { im.src = to; im.setAttribute('data-t', String(t)); }
          im.classList.remove('cho-tai'); im.classList.add('da-tai');
          xong();
        };
        lon.onerror = function () { if (_dangNap[k] === to) delete _dangNap[k]; xong(); };
        lon.src = to;
      }
      var _paintVer = 0;
      /* P4 (2026-09-15): HANG DOI tai tier — tuan tu, 1 anh mot luc, theo thu tu can dung:
         mo: [dang xem, +1, -1]; next: [dang xem, +1, +2]; prev: [dang xem, -1, -2].
         Khong doi 0,5 s, khong tai 2 anh song song (4G chia doi bang thong -> anh dang xem
         net cham); anh xong thi hang tu chay tiep (goi tu napAnh.xong). */
      var _hang = [];   // [[k, tier], ...]
      function daNet(k, t) { var im = cells[k]; return !!im && parseInt(im.getAttribute('data-t'), 10) >= (t || TIER); }
      function dangBay(k, t) { return _dangNap[k] === urlTier(photos[k].src, t || TIER) && !daNet(k, t); }
      function chayHang() {
        for (var q = 0; q < _hang.length; q++) {
          var k = _hang[q][0], t = _hang[q][1];
          if (k < 0 || k >= photos.length || daNet(k, t)) continue;
          if (dangBay(k, t)) return;              // dang co 1 anh bay: cho no xong
          napAnh(k, k === i ? 'high' : 'low', t);
          return;
        }
      }
      function datHang(ds, zoomTrangThai) {
        _hang = ds.map(function (k) { return [k, tierCan(k, zoomTrangThai)]; });
        chayHang();
      }
      function paint(huong) {
        /* P5 (2026-09-15): dang zoom ma chuyen anh -> GIU muc zoom, kep xuong cap cua anh MOI
           (px goc x dpr), pan ve giua; cap < 1,05 thi ve 1x. Truoc day moi anh moi deu ve 1x. */
        var dangZoom = zoom > 1.01 && huong;
        if (dangZoom) {
          var cap = zoomToiDa();
          if (cap < 1.05) { resetZoom(); dangZoom = false; }
          else {
            zoom = Math.min(zoom, cap); panX = 0; panY = 0; visCache = null;
            cells.forEach(function (c) { c.style.transform = ''; });
            plb.classList.add('is-zoomed'); applyT();
          }
        } else resetZoom();
        var ver = ++_paintVer;
        pcount.textContent = (i + 1) + ' / ' + photos.length;
        var nPrev = plb.querySelector('.cphoto-lb__nav--prev');
        var nNext = plb.querySelector('.cphoto-lb__nav--next');
        if (nPrev) nPrev.hidden = photos.length < 2 || i === 0;
        if (nNext) nNext.hidden = photos.length < 2 || i === photos.length - 1;
        datTrack(0);
        // Anh dang xem luon xin NGAY (hang cao) o tier cua trang thai (zoom -> tier cao nhat);
        // neu dang co anh khac bay thi van xin song song, phan con lai xep hang cung tier.
        napAnh(i, 'high', tierCan(i, dangZoom));
        datHang(huong > 0 ? [i, i + 1, i + 2] : huong < 0 ? [i, i - 1, i - 2] : [i, i + 1, i - 1], dangZoom);
      }
      function go(step) {
        var moi = Math.max(0, Math.min(photos.length - 1, i + step));
        if (moi === i) { datTrack(0); return; }
        i = moi; paint(step > 0 ? 1 : -1);
      }

      function open() {
        /* Open on whichever carousel slide is currently in view. */
        /* galleryIdx dem theo KHUNG (co ca video), con `photos` chi co anh —
           doc data-anh de doi sang dung vi tri. */
        var slMo = slides[galleryIdx];
        var iMo = slMo ? parseInt(slMo.getAttribute('data-anh'), 10) : galleryIdx;
        if (isNaN(iMo) || iMo < 0 || iMo >= photos.length) iMo = 0;
        i = iMo;
        plb.classList.remove('is-tran');       // mo lai luon HIEN chrome
        plb.hidden = false;
        doCell();
        plb.classList.add('is-keo');
        paint();
        void track.offsetWidth;                // ep reflow de vi tri an ngay
        plb.classList.remove('is-keo');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('cphoto-mo');   // an bong bong chat dang de len hang nut
        plb.querySelector('.cphoto-lb__close').focus();
      }
      function close() {
        resetZoom();
        datDoc(0);                             // xoa dau vet cu vuot, khong thi lan mo sau anh lech
        plb.hidden = true;
        document.body.style.overflow = '';
        document.body.classList.remove('cphoto-mo');   // tra bong bong chat ve
        var zb = root.querySelector('.cstrap__zoom');
        if (zb) zb.focus();
      }

      if (window.matchMedia('(max-width: 749px)').matches) {
        mainImgs.forEach(function (im) { im.addEventListener('click', open); });
      }
      var zbtn = root.querySelector('.cstrap__zoom');
      if (zbtn) zbtn.addEventListener('click', open);
      // P2/B3 (2026-09-15): khach re chuot >=150 ms len anh chinh / nut zoom, hoac cham anh (mobile),
      // hoac focus nut zoom -> nap tier cua anh dang xem NGAY, de luc bam la net (0 byte cho khach
      // khong co y dinh zoom; da nap thi bo qua).
      function napTruoc() {
        if (!plb.hidden) return;
        var sl = slides[galleryIdx];
        var k = sl ? parseInt(sl.getAttribute('data-anh'), 10) : galleryIdx;
        if (isNaN(k) || k < 0 || k >= photos.length) k = 0;
        napAnh(k, 'high');
      }
      var _reZ = null;
      var vungAnh = root.querySelector('.cstrap__media') || mainImg;
      if (vungAnh) {
        vungAnh.addEventListener('mouseenter', function () { clearTimeout(_reZ); _reZ = setTimeout(napTruoc, 60); });
        vungAnh.addEventListener('mouseleave', function () { clearTimeout(_reZ); });
        vungAnh.addEventListener('touchstart', napTruoc, { passive: true });
      }
      if (zbtn) { zbtn.addEventListener('mouseenter', napTruoc); zbtn.addEventListener('focus', napTruoc); }

      plb.querySelector('.cphoto-lb__close').addEventListener('click', close);
      plb.querySelector('.cphoto-lb__nav--prev').addEventListener('click', function () { go(-1); });
      plb.querySelector('.cphoto-lb__nav--next').addEventListener('click', function () { go(1); });
      var ZMAX = 5;
      /* P4/B (2026-09-15): khoa muc zoom theo px GOC cua anh x devicePixelRatio THAT — anh 1254 px
         tren khung 900 css @dpr 1 chi phong toi 1,39x (van 1 px anh >= 1 px man), @dpr 1,5 thi
         khong phong; anh 3328 giu 2,6x va pinch toi 5x neu du px. Px goc lay tu JSON photos.w
         (section in ra), thieu thi lay naturalWidth cua tier da tai. */
      function zoomToiDa() {
        var goc = Math.min((photos[i] && photos[i].w) || (cells[i] && cells[i].naturalWidth) || 0, TIER_ZOOM);   // CDN khong tra qua tier
        if (!goc) return ZMAX;
        var el = pimg(); var v = (el && el.naturalWidth) ? visKich() : { w: Math.min(el ? el.offsetWidth : 0, el ? el.offsetHeight : 0) };
        var can = Math.max(1, v.w) * (window.devicePixelRatio || 1);
        return Math.max(1, Math.min(ZMAX, goc / can));
      }
      var ngon = new Map();            // pointerId -> {x, y}
      var dragging = false, moved = false, sx = 0, sy = 0, px0 = 0, py0 = 0;
      var Cx = 0, Cy = 0, d0 = 0, z0 = 1, p0x = 0, p0y = 0, u0x = 0, u0y = 0, chum = false;

      function ds() { return Array.from(ngon.values()); }
      function khoangCach(a) { return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); }
      function diemGiua(a) { return { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 }; }

      function batDauChum() {
        napTierZoom();
        datHang([i, i + 1, i - 1], true);
        var a = ds();
        var r = pimg().getBoundingClientRect();
        Cx = r.left + r.width / 2 - panX;      // tam anh khi chua bien doi
        Cy = r.top + r.height / 2 - panY;
        d0 = khoangCach(a) || 1;
        z0 = zoom; p0x = panX; p0y = panY;
        var m = diemGiua(a);
        u0x = (m.x - Cx - panX) / zoom;        // diem anh nam duoi giua hai ngon
        u0y = (m.y - Cy - panY) / zoom;
        huyTap();                              // tap dang cho khong duoc no giua chum
        visCache = visKich();
        chum = true;
        dragging = false;
        // ngon thu 2 dat xuong giua luc dang keo track: huy keo, bat track ve cho
        if (keoTrack) { keoTrack = false; plb.classList.remove('is-keo'); datTrack(0); }
        pimg().classList.remove('is-grabbing');
        plb.classList.add('is-pinching');      // tat hieu ung chuyen, khong thi giat
      }

      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      stage.addEventListener('wheel', function (e) {
        e.preventDefault();
        var z1 = Math.max(1, Math.min(zoomToiDa(), zoom * (e.deltaY < 0 ? 1.2 : 1 / 1.2)));
        if (z1 > 1) { napTierZoom(); datHang([i, i + 1, i - 1], true); }
        if (z1 === zoom) return;
        var r = pimg().getBoundingClientRect();
        var Cwx = r.left + r.width / 2 - panX, Cwy = r.top + r.height / 2 - panY;
        var ux = (e.clientX - Cwx - panX) / zoom, uy = (e.clientY - Cwy - panY) / zoom;
        zoom = z1;
        if (zoom <= 1.01) { resetZoom(); return; }
        panX = e.clientX - Cwx - zoom * ux;
        panY = e.clientY - Cwy - zoom * uy;
        clampPan(); applyT();
        plb.classList.add('is-zoomed');
      }, { passive: false });
      var keoTrack = false, ktX = 0, ktDx = 0, ktV = 0, ktT = 0;

      /*
        Vuot doc de dong. `huong` khoa mot lan o vai pixel dau: 0 chua biet, 1 ngang
        (chuyen anh), 2 doc (dong). Doan lai moi khung hinh thi mot cu vuot cheo se vua
        truot anh vua keo dong cung luc.
      */
      var ktY = 0, huong = 0, kdDy = 0, kdTruoc = 0, kdV = 0, kdT = 0;
      var NEN_GOC = 'rgba(10, 10, 10, 1)';

      function datDoc(dy) {
        stage.style.transform = dy ? ('translateY(' + dy + 'px)') : '';
        /* Nen mo dan theo quang duong keo: khach thay ngay cu chi nay dang dong, khong phai
           doan. 320px la quang duong den trong suot hoan toan — dai hon nguong dong that
           (110px) nen luc buong tay nen van con du dam de khong giat. */
        if (!dy) { plb.style.backgroundColor = ''; return; }
        var m = Math.min(1, Math.abs(dy) / 320);
        plb.style.backgroundColor = 'rgba(10, 10, 10, ' + (1 - m * 0.75).toFixed(3) + ')';
      }
      track.addEventListener('pointerdown', function (e) {
        ngon.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (ngon.size === 2) {
          batDauChum();
          e.preventDefault();
          return;
        }
        if (ngon.size === 1 && zoom > 1) {     // keo de di chuyen anh
          dragging = true; moved = false;
          sx = e.clientX; sy = e.clientY; px0 = panX; py0 = panY;
          visCache = visKich();
          pimg().classList.add('is-grabbing');
          e.preventDefault();
          return;
        }
        if (ngon.size === 1 && zoom === 1) {   // keo track chuyen anh HOAC vuot doc de dong
          keoTrack = true; moved = false; ktX = e.clientX; ktDx = 0;
          ktV = 0; ktT = performance.now();
          ktY = e.clientY; huong = 0; kdDy = 0; kdTruoc = 0; kdV = 0; kdT = ktT;
          plb.classList.add('is-keo');
          e.preventDefault();
        }
      });
      // will-change chuyen sang DAT SAN trong CSS (spec delugs bay #3: gan luc keo la
      // qua tre) — khong con toggle theo cu chi.

      document.addEventListener('pointermove', function (e) {
        if (ngon.has(e.pointerId)) ngon.set(e.pointerId, { x: e.clientX, y: e.clientY });

        if (chum && ngon.size >= 2) {
          var a = ds();
          zoom = Math.max(1, Math.min(zoomToiDa(), z0 * (khoangCach(a) / d0)));
          var m = diemGiua(a);
          panX = m.x - Cx - zoom * u0x;
          panY = m.y - Cy - zoom * u0y;
          clampPan(); applyT();
          plb.classList.toggle('is-zoomed', zoom > 1.01);
          moved = true;                        // cu bam ket thuc khong duoc coi la mot cu cham
          e.preventDefault();
          return;
        }

        if (keoTrack) {
          var dxt = e.clientX - ktX;
          var dyt = e.clientY - ktY;

          /* Khoa huong mot lan. Nguong 1.2 nghieng ve phia NGANG: truot xem anh la cu chi
             chinh o day, dong chi la loi thoat — de cu vuot ngang hoi cheo van chuyen anh. */
          if (!huong && (Math.abs(dxt) > 6 || Math.abs(dyt) > 6)) {
            huong = Math.abs(dyt) > Math.abs(dxt) * 1.2 ? 2 : 1;
          }

          if (huong === 2) {
            moved = true;
            var lucD = performance.now();
            kdV = (dyt - kdTruoc) / Math.max(1, lucD - kdT);
            kdT = lucD; kdTruoc = dyt; kdDy = dyt;
            datDoc(dyt);
            return;
          }

          if (Math.abs(dxt) > 4) moved = true;
          if ((i === 0 && dxt > 0) || (i === photos.length - 1 && dxt < 0)) dxt *= 0.35;
          var luc = performance.now();
          ktV = (dxt - ktDx) / Math.max(1, luc - ktT);   // van toc px/ms cho cu HAT
          ktT = luc;
          ktDx = dxt;
          datTrack(dxt);
          return;
        }

        if (!dragging) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
        panX = px0 + dx; panY = py0 + dy; clampPan(); applyT();
      });

      function nhacNgon(e) {
        ngon.delete(e.pointerId);
        if (chum && ngon.size < 2) {
          chum = false;
          plb.classList.remove('is-pinching');
          if (zoom <= 1.01) resetZoom();       // tha ra o muc 1x thi ve vua khung
          if (ngon.size === 1 && zoom > 1) {
            var a = ds()[0];
            dragging = true; moved = true;
            sx = a.x; sy = a.y; px0 = panX; py0 = panY;
          }
        }
        if (!ngon.size && keoTrack) {
          keoTrack = false;
          plb.classList.remove('is-keo');      // transition bat lai TRUOC khi dat dich
          if (huong === 2) {
            /* Du xa HOAC du nhanh thi dong. Cu hat nhanh mot doan ngan cung phai an —
               nguoi ta hat chu khong keo, va bat nguoc lai luc do doc nhu bi tu choi. */
            var dong = Math.abs(kdDy) > 110 || (Math.abs(kdDy) > 40 && Math.abs(kdV) > 0.4);
            datDoc(0);
            if (dong) close();
          } else if (Math.abs(ktDx) > Math.min(160, cellW * 0.15) || (Math.abs(ktDx) > 40 && Math.abs(ktV) > 0.35)) {
            go(ktDx < 0 ? 1 : -1);
          } else {
            datTrack(0);                       // bat ve cho cu, co transition = muot
          }
          ktDx = 0; ktV = 0; kdDy = 0; kdV = 0; huong = 0;
        }
        if (!ngon.size && dragging) { dragging = false; pimg().classList.remove('is-grabbing'); }
        if (!ngon.size) {                      // het cu chi: don will-change + cache
          track.style.willChange = '';
          pimg().style.willChange = '';
          visCache = null;
        }
      }
      document.addEventListener('pointerup', nhacNgon);
      document.addEventListener('pointercancel', nhacNgon);

      function zoomTaiDiem(cx, cy) {
        var toiDa = zoomToiDa();
        if (toiDa < 1.05) return;                // anh khong du px de phong: khong zoom, khong mo
        zoom = Math.min(ZOOM, toiDa);
        napTierZoom();
        datHang([i, i + 1, i - 1], true);        // P5: anh ke cung len tier zoom
        var r = pimg().getBoundingClientRect();
        panX = (cx - (r.left + r.width / 2)) * (1 - zoom);
        panY = (cy - (r.top + r.height / 2)) * (1 - zoom);
        clampPan();
        plb.classList.add('is-zoomed');
        applyT();
      }
      var tapTimer = null, tapX = 0, tapY = 0;
      function huyTap() { if (tapTimer) { clearTimeout(tapTimer); tapTimer = null; } }
      track.addEventListener('click', function (e) {
        if (moved) { moved = false; return; }   // cu bam do la ket thuc mot cu keo hoac chum
        // ly dong viewer (kieu delugs), khong zoom vao khoang trang.
        if (!e.target.closest('.cphoto-lb__cell')) return;
        if (!LA_MOBILE) {
          if (zoom === 1) {
            // Bam vao VUNG DEN trong cell (ngoai mep anh that) = thoat ve product
            // (delugs); bam TREN anh = zoom tai diem.
            var vb = visKich();
            var rb = pimg().getBoundingClientRect();
            if (Math.abs(e.clientX - (rb.left + rb.width / 2)) > vb.w / 2 ||
                Math.abs(e.clientY - (rb.top + rb.height / 2)) > vb.h / 2) { close(); return; }
            zoomTaiDiem(e.clientX, e.clientY);
          } else {
            resetZoom();
          }
          return;
        }
        if (tapTimer && Math.hypot(e.clientX - tapX, e.clientY - tapY) < 30) {
          huyTap();                              // DOUBLE-TAP
          if (zoom === 1) zoomTaiDiem(e.clientX, e.clientY);
          else resetZoom();
          return;
        }
        huyTap();
        tapX = e.clientX; tapY = e.clientY;
        tapTimer = setTimeout(function () {
          tapTimer = null;
          plb.classList.toggle('is-tran');       // TAP-1: an/hien chrome
        }, 280);
      });
      /* Backdrop closes; the picture and the buttons do not. */
      plb.addEventListener('click', function (e) { if (e.target === plb) close(); });
      stage.addEventListener('click', function (e) {
        if (moved) { moved = false; return; }
        if (e.target === stage || e.target === track) close();
      });

      document.addEventListener('keydown', function (e) {
        if (plb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });
    })();

    var lb = document.getElementById('cswatch-lb-' + SID + '');
    var nameEl = lb.querySelector('.cswatch-lb__name');
    var stage = lb.querySelector('.cswatch-lb__stage');
    var counter = lb.querySelector('.cswatch-lb__counter');
    var prevBtn = lb.querySelector('.cswatch-lb__nav--prev');
    var nextBtn = lb.querySelector('.cswatch-lb__nav--next');
    var zItems = [];
    var zIndex = 0;

    /* Dawn's scroll animations put a transform on the section, which breaks
       position:fixed for descendants. Re-parent the dialogs to <body>. */
    ['cswatch-lb-' + SID + '', 'sguide-lb-' + SID + '', 'chelp-lb-' + SID + ''].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.parentNode !== document.body) document.body.appendChild(el);
    });

    function openModal(el) {
      el.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeModal(el) {
      el.hidden = true;
      document.body.style.overflow = '';
    }

    /* Skin -> Kind -> Colour cascade */
    var skinSel = document.getElementById('cf-' + SID + '-skin-of-leather');
    var kindSel = document.getElementById('cf-' + SID + '-kind-of-leather');
    var colorBox = document.getElementById('cstrap-color-' + SID + '');
    var dataEl = document.getElementById('cstrap-leather-' + SID + '');
    /*
      Catalog da (colors/palette/swatchImg/soldOut) doc o day, ngoai guard Skin/Kind, vi tu 14/09 luoi
      mau LOT DA cung dung no — va bai day san khong co hai o Skin/Kind. Khoi cstrap-lining mang mau
      rieng cua Zermatt (khong nam trong catalog da) + danh sach da lot hien trong dropdown.
    */
    var DATA = null, LINING = null;
    try { DATA = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { DATA = null; }
    var liningEl = document.getElementById('cstrap-lining-' + SID + '');
    try { LINING = liningEl ? JSON.parse(liningEl.textContent) : null; } catch (e) { LINING = null; }

    /*
      Mot bo dung luoi mau cho ca hai: luoi DA (properties[Colour], hop cstrap-color-<sid>) va luoi LOT
      (properties[Lining Colour], hop cstrap-color-lining-<sid>). Cung o anh, cung viec khoa mau het hang,
      cung nut zoom — khac nhau chi o ten thuoc tinh, nhan va viec co tick san hay khong.
    */
  function buildColourGrid(kind, box, propName, labelHtml, preCheck) {
      var names = (DATA && DATA.colors && DATA.colors[kind]) || (LINING && LINING.own && LINING.own[kind]) || [];
      if (!names.length) { box.innerHTML = ''; box.hidden = true; return false; }

      var label = document.createElement('span');
      label.className = 'cfield__label';
      /*
        The heading names the leather and, once a swatch is clicked, carries the colour: "LIZARD
        COLOUR: Black". The colon is rendered here so the echo the field machinery appends lands
        in a sentence, not against a bare label; before any pick the colon simply invites one.
      */
      label.innerHTML = labelHtml;

      var grid = document.createElement('div');
      grid.className = 'ccolor-grid';

      /* Two leathers can own the same colour NAME and not the same colour: Lizard Brown is a
         different hide from Ostrich Brown, and a flat name key would hand one of them the other's
         swatch. A "Kind::Colour" key wins when present; the plain name stays the fallback so every
         leather written before this change keeps working untouched. */
      /* Tra bang cua catalog da truoc, roi bang rieng cua lot da (Zermatt) — cung mot khoa "Kind::Colour". */
      function pick(key, name) {
        var maps = [DATA && DATA[key], LINING && LINING[key]];
        for (var m = 0; m < maps.length; m++) {
          var map = maps[m];
          if (!map) continue;
          var scoped = map[kind + '::' + name];
          if (scoped !== undefined) return scoped;
          if (map[name] !== undefined) return map[name];
        }
        return null;
      }

      var daBatBuoc = false;
      names.forEach(function (name, i) {
        var hex = pick('palette', name) || '#888888';

        var wrap = document.createElement('label');
        wrap.className = 'ccolor';
        wrap.title = name;

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = propName;
        input.value = name;
        /* Mau het hang: KHOA han o. Chi lam mo thi o van bam duoc va van chon duoc
           bang ban phim — khach dat mau khong co hang, xuong xuong may moi lo ra.
           Nut zoom van bam duoc: van cho khach ngam tam da. */
        var hetHang = !!pick('soldOut', name);
        if (hetHang) {
          wrap.className += ' ccolor--het';
          input.disabled = true;
          wrap.title = name + ' \u2014 out of stock';
          wrap.setAttribute('aria-disabled', 'true');
        } else if (!daBatBuoc) {
          /* `required` phai bam o CON HANG dau tien: dat tren o disabled thi trinh
             duyet bo qua, ca truong mau het bat buoc. */
          input.required = true;
          daBatBuoc = true;
        }

        var zoom = document.createElement('button');
        zoom.type = 'button';
        zoom.className = 'sw-zoom';
        zoom.setAttribute('data-zoom-name', name);
        zoom.setAttribute('data-zoom-color', hex);
        zoom.setAttribute('aria-label', 'Zoom ' + name);
        zoom.innerHTML =
          '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true">' +
          '<circle cx="7" cy="7" r="5"></circle><line x1="10.8" y1="10.8" x2="15" y2="15"></line></svg>';

        var tile = document.createElement('span');
        tile.className = 'ccolor__tile';
        tile.style.setProperty('--c', hex);
        var simg = pick('swatchImg', name);
        if (simg) {
          tile.className += ' ccolor__tile--photo';
          var snho = simg + (simg.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
          /* #2 (2026-09-16): o swatch xep hang THAP. Khi khach doi dong da, luoi mau dung lai
             TRUOC roi preview moi render — 10 anh swatch o hang thuong se chen len truoc anh
             NEN cua dong da moi, keo vong xoay dai them ~1 s (do 16/09: doi dong da 34 file,
             anh nen ve o 1,2-2,7 s). Swatch nho (width=160, ~9 KB) va khong phai thu khach
             dang cho, nen nhuong duong cho anh nen. */
          tile.innerHTML = '<img src="' + snho + '" data-zoom-src="' + simg + '" alt="" loading="lazy" fetchpriority="low">';
        }

        var text = document.createElement('span');
        text.className = 'ccolor__n';
        text.textContent = name;

        wrap.appendChild(input);
        wrap.appendChild(zoom);
        wrap.appendChild(tile);
        wrap.appendChild(text);
        grid.appendChild(wrap);
      });

      /* Lot da: o dau con hang duoc tick san (Zermatt Gold nhu truoc); luoi da thi khach phai tu chon. */
      if (preCheck) {
        var dau = grid.querySelector('input[type="radio"]:not([disabled])');
        if (dau) dau.checked = true;
      }

      box.innerHTML = '';
      box.appendChild(label);
      box.appendChild(grid);
      box.hidden = false;
      return true;
    }


    if (skinSel && kindSel && colorBox && DATA) {
      /* 21/09 (chu shop): bang mau MOI dong da IN SAN trong HTML (snippets/cstrap-color-palettes.liquid, <fieldset data-kind>) —
         JS chi AN/HIEN: bang an thi moi radio bi disabled (khong can validation, khong len don, deep-link chamRadio bo qua) va bo tick.
         Dong khong co bang in san (catalog 'full') van dung JS vao <div data-kind-js> nhu cu. */
      function moiBang() { return colorBox.querySelectorAll('fieldset[data-kind]'); }
      /* 11/10 LAG B5: bang da in san chi doi trang thai khi THAT SU doi (truoc: moi lan doi dong da ghi lai hidden + disabled + checked cua ~124 radio
         ke ca bang van an -> moi ghi la 1 mutation + invalidate :has()). Bang da o dung trang thai thi bo qua. */
      function hienBang(f, on) {
        if (f.__bangOn === on) return;
        f.__bangOn = on;
        if (f.hidden !== !on) f.hidden = !on;
        var rs = f.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < rs.length; i++) {
          if (!on && rs[i].checked) rs[i].checked = false;
          var dis = !on || rs[i].hasAttribute('data-het');
          if (rs[i].disabled !== dis) rs[i].disabled = dis;
        }
      }
      function hopJs() {
        var js = colorBox.querySelector('[data-kind-js]');
        if (!js) { js = document.createElement('div'); js.className = 'cfield'; js.setAttribute('data-kind-js', ''); js.hidden = true; colorBox.appendChild(js); }
        return js;
      }
      function resetColours() {
        var fs = moiBang(); for (var i = 0; i < fs.length; i++) hienBang(fs[i], false);
        var js = colorBox.querySelector('[data-kind-js]'); if (js) { js.innerHTML = ''; js.hidden = true; }
        colorBox.hidden = true;
      }

      function buildColours(kind) {
        var fs = moiBang(), co = false;
        for (var i = 0; i < fs.length; i++) { var on = fs[i].getAttribute('data-kind') === kind; hienBang(fs[i], on); if (on) co = true; }
        var js = colorBox.querySelector('[data-kind-js]');
        if (co) {
          if (js) { js.innerHTML = ''; js.hidden = true; }
          colorBox.hidden = false;
          try { capLeatherGrid(); } catch (e) { if (window.console) console.warn('buildColours capLeatherGrid loi:', e); }
          return true;
        }
        js = hopJs(); js.hidden = false;
        var ok = buildColourGrid(kind, js, 'properties[Colour]',
          kind + ' Colour <span class="req">*</span><span class="cfield__colon">:</span>', false);
        colorBox.hidden = !ok;
        return ok;
      }

      skinSel.addEventListener('change', function () {
        var kinds = DATA.skins[skinSel.value] || [];
        kindSel.innerHTML = '';
        var ph = document.createElement('option');
        ph.value = '';
        ph.disabled = true;
        ph.selected = true;
        ph.textContent = kinds.length ? 'Select leather' : 'Pick a skin first';
        kindSel.appendChild(ph);
        /*
          The VALUE stays the bare leather name — the order property, the preview's KIND map and the
          variant matcher all key on it — only the visible text carries the price, so the customer
          reads "Lizard ($109)" and everything downstream still reads "Lizard".
        */
        /* Gia tung da: Liquid dua san map ten -> "$109" (thang gia: rules.leatherBase; nhanh cu: bien the). */
        var LPRICE = DATA.leatherPrice || {};
        kinds.forEach(function (k) {
          var opt = document.createElement('option');
          opt.value = k;
          opt.textContent = LPRICE[k] ? k + ' (' + LPRICE[k] + ')' : k;
          kindSel.appendChild(opt);
        });
        /*
          Rebuilding this list empties it, and a select the customer did not touch fires no change
          event — so nothing would tell it to stop looking answered. It would sit there in full ink
          and semibold reading "Select leather", which is the placeholder wearing the answer's
          clothes. The same call the thickness list makes after its own rebuild, for the same reason.
        */
        syncFieldHint(kindSel.closest('.cfield'));
        resetColours();
      });

      kindSel.addEventListener('change', function () {
        buildColours(kindSel.value);
      });
      /* 21/09: Liquid chon san Regular · Epsom va in bang Epsom hien — bao 'change' Kind mot lan sau khi moi listener da gan
         (thang gia, hint, preview) nhu khach vua chon; KHONG ban change Skin (se dung lai Kind va an bang). Deep-link tu dat lai. */
      if (kindSel.value && !/[?&](leather|colour|color)=/.test(location.search)) {
        setTimeout(function () { try { kindSel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { if (window.console) console.warn('kind mac dinh loi:', e); } }, 0);
      }

      (function deepLink() {
        var q = new URLSearchParams(location.search);
        var lay = function (k) { return (q.get(k) || '').trim(); };
        var mDa = lay('leather');
        var mMau = lay('colour') || lay('color');
        if (/^blue grey$/i.test(mMau) && /^ostrich( quill)?$/i.test(mDa)) mMau = 'Grey';   /* 26/10: link cu "Blue Grey" -> o "Grey" sau khi doi ten (Ostrich) */
        var mKieu = lay('style');
        var mChi = lay('stitch');
        var mVien = lay('edge');
        var mKeeper = lay('keeper');
        var mLo = lay('hole') || lay('underlay');   /* mau lot lo ra qua lo rally */
        var mDang = lay('form');          /* Flat / Padded */
        var mMui = lay('tip');            /* Regular (pointed) / Square / Oval / Pilot */
        var mKieuChi = lay('stitchstyle');/* Classic Stitches / Box Stitches / ... */
        var mKhoa = lay('buckle');        /* Classic — Silver / Pre-V — Gold / ... */
        var mKeeper2 = lay('keeper2');    /* dia thu 2 khac mau dia 1 */
        var mCong = lay('curved');        /* Yes / No — dau lug cat cong (+tien, la BIEN THE) */
        /* don=1: dang mo lai mot don DA MUA (link trong bang don hang cua xuong).
           Mau co the da het hang tu luc do — van phai hien dung cai khach chon.
           Het hang chi chan don MOI. */
        var xemLai = lay('don') === '1';
        if (!mDa && !mKieu && !mChi && !mVien && !mKeeper && !mLo
            && !mDang && !mMui && !mKieuChi && !mKhoa && !mKeeper2 && !mCong) return;

        window.CSTRAP_DEEPLINK = true;
        window.CSTRAP_DEEPLINK_HOLE = mLo || '';
        /* Xem lai: khoa nut them vao gio. Thiet ke nay da mua roi, va mot trong
           cac mau co the da het hang — cho NHIN chu khong cho dat lai. */
        if (xemLai) {
          setTimeout(function () {
            var nut = root.querySelector('[type="submit"]');
            if (!nut) return;
            nut.setAttribute('disabled', 'disabled');
            nut.setAttribute('aria-disabled', 'true');
            var bao = document.createElement('p');
            bao.className = 'cstrap-xemlai';
            bao.style.cssText = 'margin:.8rem 0 0;font-weight:600;text-align:center';
            bao.textContent = 'You are viewing a design from an existing order.';
            if (nut.parentNode) nut.parentNode.appendChild(bao);
          }, 1200);
        }
        var haCo = function () {
          setTimeout(function () {
            window.CSTRAP_DEEPLINK = false;
            window.CSTRAP_DEEPLINK_HOLE = '';
          }, 3200);
        };
        setTimeout(function () { window.CSTRAP_DEEPLINK = false; }, 9000);

        /* Doi mot khung hinh — nhieu buoc chi dung xong o chon o khung ke tiep. */
        function sau(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }

        function chamRadio(ten, giaTri) {
          if (!giaTri) return false;
          var ds = (typeof ten === 'string') ? [ten] : ten;
          for (var k = 0; k < ds.length; k++) {
            var o = root.querySelectorAll('input[name="properties[' + ds[k] + ']"]');
            for (var i = 0; i < o.length; i++) {
              /* Bo qua o bi khoa: .checked van dat duoc va van hien dau tick, nhung
                 input disabled KHONG gui gia tri len don — khach tuong da chon.
                 Tru khi dang XEM LAI don cu: luc do chi de nhin, khong ban. */
              if (o[i].value === giaTri && (xemLai || !o[i].disabled)) {
                o[i].checked = true;
                o[i].dispatchEvent(new Event('change', { bubbles: true }));
                return true;
              }
            }
          }
          return false;
        }

        /* 2026-09-16: nut 2D cua bai dau cong sinh link ...&form=Padded&curved=Yes tu lau,
           nhung deepLink chua doc tham so nay — khach bam tu bai dau cong van thay dau thang.
           Tim o theo ID chu KHONG theo name: dau cong la mot bien the co gia, nen tren bai co
           tinh tien section bo thuoc tinh name di (bien the noi thay o don hang) va mot phep
           tim theo properties[Curved End] se khong thay gi. Doi o -> change de gia, bien the
           va ban ve 2D cung cap nhat. */
        function datCong() {
          if (!mCong) return false;
          var sel = root.querySelector('select[id$="-curved-end"]') || radioNhuSelect('Curved End', 'data-curved-end');   /* 21/09: o Curved End la tile radio */
          if (!sel) return false;
          var muon = /^(yes|y|1|true|curved|co)$/i.test(mCong) ? 'Yes'
                   : (/^(no|n|0|false|straight|khong)$/i.test(mCong) ? 'No' : '');
          if (!muon) return false;
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value.indexOf(muon) === 0) {
              if (sel.value === sel.options[i].value) return true;
              sel.value = sel.options[i].value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              return true;
            }
          }
          return false;
        }

        var CUNG_TONG = ['Tone on tone', 'Match leather', 'As Pictured'];

        function chonO(ten, giaTri) {
          if (!giaTri) return false;
          var sel = root.querySelector('select[name="properties[' + ten + ']"]');
          if (!sel) return false;
          for (var i = 0; i < sel.options.length; i++) {
            var v = sel.options[i].value;
            if (v === giaTri || v.indexOf(giaTri) === 0) {
              sel.value = v;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              return true;
            }
          }
          return false;
        }

        function datHaiDia(m1, m2, xong) {
          var sel = root.querySelector('select[name="properties[Keeper Colour]"]');
          if (sel) {
            for (var i = 0; i < sel.options.length; i++) {
              if (/two colours/i.test(sel.options[i].value)) {
                sel.value = sel.options[i].value;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
                break;
              }
            }
          }
          sau(function () {
            chamRadio('Custom Keeper Colour', m1);
            sau(function () { chamRadio('Custom Keeper 2 Colour', m2); if (xong) xong(); });
          });
        }

        function datMau(tenCong, tenBang, giaTri, xong) {
          if (!giaTri) { if (xong) xong(); return; }
          var laCungTong = CUNG_TONG.indexOf(giaTri) !== -1;
          var ung = laCungTong ? CUNG_TONG : [giaTri];
          var sel = root.querySelector('select[name="properties[' + tenCong + ']"]');
          if (sel) {
            for (var k = 0; k < ung.length; k++) {
              for (var i = 0; i < sel.options.length; i++) {
                var v = sel.options[i].value;
                /* khop TIEN TO: cac cong mang hau to dong "(recommended)" */
                if (v === ung[k] || v.indexOf(ung[k]) === 0) {
                  sel.value = v;
                  sel.dispatchEvent(new Event('change', { bubbles: true }));
                  if (xong) xong();
                  return;
                }
              }
            }
          }
          if (laCungTong) {
            if (mMau) chamRadio(tenBang, mMau);
            if (xong) xong();
            return;
          }
          if (sel) {
            for (var j = 0; j < sel.options.length; j++) {
              if (sel.options[j].value.indexOf('Custom') === 0) {
                sel.value = sel.options[j].value;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
                break;
              }
            }
          }
          sau(function () { chamRadio(tenBang, giaTri); if (xong) xong(); });
        }

        function buoc1_da() {
          if (!mDa) return buoc3_kieu();
          var nhom = null;
          Object.keys(DATA.skins || {}).forEach(function (g) {
            if ((DATA.skins[g] || []).indexOf(mDa) !== -1) nhom = g;
          });
          if (!nhom) return buoc3_kieu();          skinSel.value = nhom;
          skinSel.dispatchEvent(new Event('change', { bubbles: true }));
          kindSel.value = mDa;
          kindSel.dispatchEvent(new Event('change', { bubbles: true }));
          sau(buoc2_mauDa);
        }

        function buoc2_mauDa() {
          if (mMau && (DATA.colors[mDa] || []).indexOf(mMau) !== -1) chamRadio('Colour', mMau);
          sau(buoc3_kieu);
        }

        function buoc3_kieu() {
          if (mDang) chonO('Strap form', mDang);
          sau(function () {
            datCong();
            if (mKieu) chamRadio('Style of Strap', mKieu);
            sau(buoc4_mauPhu);
          });
        }

        function doiChieu(luot) {
          var can = [
            ['Colour', mMau], ['Style of Strap', mKieu], ['Thread Colour', mChi],
            ['Custom Edge Colour', mVien], ['Custom Keeper Colour', mKeeper],
            [['Underlay Colour', 'Custom Underlay Colour'], mLo],
            ['Style of Stitches', mKieuChi], ['Tip Shape', mMui],
            ['Custom Keeper 2 Colour', mKeeper2]
          ];
          for (var i = 0; i < can.length; i++) {
            var ten = can[i][0], gt = can[i][1];
            if (!gt || CUNG_TONG.indexOf(gt) !== -1) continue;
            var ds = (typeof ten === 'string') ? [ten] : ten;
            var dangCo = null;
            for (var k = 0; k < ds.length && !dangCo; k++) {
              var o = root.querySelector('input[name="properties[' + ds[k] + ']"]:checked');
              if (o) dangCo = o.value;
            }
            if (dangCo !== gt) chamRadio(ten, gt);
          }
          /* Khoa doi chieu rieng vi no co hai ten goi. */
          if (mKhoa) {
            var dk = root.querySelector('input[name="properties[Buckle Finish]"]:checked');
            /* Khoa gap co BA ten goi: "Deployant Clasp" (ten khach thay tu
               2026-09-03), "Deployant Clasp" (ten cu, con nam tren don da dat)
               va "Butterfly Clasp" (ten dung o trang builder). Doi chieu phai
               bo qua phan dau ay roi so phan duoi. */
            var DAU_KHOA = /^(Folding Clasp|Omega Clasp|Omega Buckle|Deployant Clasp|Butterfly Clasp)/;
            var hau = mKhoa.replace(DAU_KHOA, '');
            if (!dk || dk.value.replace(DAU_KHOA, '') !== hau) {
              if (!chamRadio('Buckle Finish', mKhoa)) {
                chamRadio('Buckle Finish', /^(Folding Clasp|Omega Clasp|Omega Buckle|Deployant Clasp)/.test(mKhoa)
                  ? mKhoa.replace(DAU_KHOA, 'Butterfly Clasp')
                  : mKhoa.replace(DAU_KHOA, 'Deployant Clasp'));
              }
            }
          }
          datCong();
          if (luot < 2) { setTimeout(function () { doiChieu(luot + 1); }, 800); return; }
          haCo();          /* het ba luot (0, 800ms, 1600ms) thi tra quyen lai cho form */
        }

        function buoc4_mauPhu() {
          /* dat lai mau da: buoc 3 (kieu day) vua dung lai bang mau */
          if (mMau && (DATA.colors[mDa] || []).indexOf(mMau) !== -1) chamRadio('Colour', mMau);
          if (mKieuChi) { chonO('Stitch Style', 'Custom style'); chamRadio('Style of Stitches', mKieuChi); }
          if (mMui) chamRadio('Tip Shape', mMui);
          if (mKhoa) {
            if (!chamRadio('Buckle Finish', mKhoa)) {
              var DAU_KHOA4 = /^(Folding Clasp|Omega Clasp|Omega Buckle|Deployant Clasp|Butterfly Clasp)/;
              var doi = /^(Folding Clasp|Omega Clasp|Omega Buckle|Deployant Clasp)/.test(mKhoa)
                ? mKhoa.replace(DAU_KHOA4, 'Butterfly Clasp')
                : (/^Butterfly Clasp/.test(mKhoa)
                    ? mKhoa.replace(DAU_KHOA4, 'Deployant Clasp') : '');
              if (doi) chamRadio('Buckle Finish', doi);
            }
          }
          sau(function () {
            datMau('Stitch Colour', 'Thread Colour', mChi, function () {
              datMau('Edge colour', 'Custom Edge Colour', mVien, function () {
                sau(function () {
                  (mKeeper2
                    ? function (xong) { datHaiDia(mKeeper, mKeeper2, xong); }
                    : function (xong) { datMau('Keeper Colour', 'Custom Keeper Colour', mKeeper, xong); }
                  )(function () {
                    datMau('Underlay Colour',
                           ['Custom Underlay Colour', 'Underlay Colour'], mLo, function () {
                      doiChieu(0);
                    });
                  });
                });
              });
            });
          });
        }

        sau(buoc1_da);
      })();
    }

    /* Mac dinh khi khach mo trang: dien san cau hinh ban chay nhat.
       TAT tren cac trang custom qua cai dat prefill_defaults: o do khach tu dung
       tu dau, dien san la ap dat mot cau hinh khach chua he chon. */
    (function macDinh() {
      if (CFG && CFG.prefill === false) return;
      var DL = ['leather', 'colour', 'color', 'style', 'stitch', 'edge', 'keeper',
                'hole', 'underlay', 'form', 'tip', 'stitchstyle', 'buckle', 'keeper2', 'curved'];
      var q = new URLSearchParams(location.search);
      for (var d = 0; d < DL.length; d++) if (q.get(DL[d])) return;

      var THICK = { 'Flat': '3.5 mm', 'Padded': '4.5 mm' };
      var CHON = [['Lug Width', '20/18 mm'], ['Length', '125/75 mm']]   /* 08/10 16:44: khop tien to gia tri moi "125/75 mm — wrist …" */;
      var TICK = [['Buckle Finish', 'Classic — Silver'], ['Spring bar', 'Regular Spring Bars']];

      function o(ten) { return root && root.querySelector('select[name="properties[' + ten + ']"]'); }

      function datO(sel, giaTri, chiKhiTrong) {
        if (!sel || (chiKhiTrong && sel.value)) return false;
        for (var i = 0; i < sel.options.length; i++) {
          var v = sel.options[i].value;
          if (v && (v === giaTri || v.indexOf(giaTri) === 0)) {
            sel.value = v;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }
        return false;
      }

      function datTick(ten, giaTri) {
        var ds = root.querySelectorAll('input[name="properties[' + ten + ']"]');
        /* defaultChecked = thuoc tinh may chu in ra. Lech nghia la khach da bam. */
        for (var i = 0; i < ds.length; i++) {
          if (ds[i].checked && !ds[i].defaultChecked) return false;
        }
        for (var j = 0; j < ds.length; j++) {
          if (ds[j].value === giaTri || ds[j].value.indexOf(giaTri) === 0) {
            ds[j].checked = true;
            ds[j].dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }
        return false;
      }

      function sau2(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }

      /* Thickness do JS dung lai moi khi Strap form doi, nen phai dat o khung hinh sau. */
      function theoForm() {
        var f = o('Strap form');
        var d = f && THICK[/^Padded/.test(f.value) ? 'Padded' : f.value];   /* 09/10: Padded Domed / Square / Full = Padded */
        if (d) datO(o('Thickness'), d, false);
      }

      var lan = 0;
      (function cho() {
        var lug = o('Lug Width');
        if ((!lug || lug.options.length < 2) && lan++ < 60) return requestAnimationFrame(cho);
        if (!lug) return;

        CHON.forEach(function (x) { datO(o(x[0]), x[1], true); });
        TICK.forEach(function (x) { datTick(x[0], x[1]); });

        /* Chi dien luc mo trang. Khach doi form la viec cua khach — khong dat ho
           Thickness nua, ho da co con so rieng trong dau. */
        var f = o('Strap form');
        if (!f || f.value) return;
        /* Dang day lay tu metafield builder2d.strap_form, khong co thi tu tieu de.
           San pham ten "Padded ..." phai mo ra Padded chu khong phai Flat. */
        var dang = (CFG && CFG.strapForm ? String(CFG.strapForm).trim() : '');
        if (!THICK[/^Padded/i.test(dang) ? 'Padded' : dang]) dang = 'Flat';   /* 09/10: 'Padded' cu -> datO khop tien to -> Padded Domed */
        datO(f, dang, true);
        sau2(theoForm);
      })();
    })();

    /* Grab-and-drag the option rows left/right with the mouse.
       Pointer capture keeps the drag alive even when the cursor leaves the row. */
    function enableDrag(el) {
      var active = false, startX = 0, startLeft = 0, moved = false;

      /* NOTE: never call setPointerCapture here. Capturing the pointer re-targets the
         following click to this row, so it never reaches the <label> and no option can
         be picked. Listen on document instead, and only treat it as a drag once the
         cursor has actually travelled — a still click stays a plain click. */
      function onMove(e) {
        if (!active) return;
        var dx = e.clientX - startX;

        if (!moved) {
          if (Math.abs(dx) <= 4) return;
          moved = true;
          el.classList.add('is-dragging');
        }

        e.preventDefault();
        el.scrollLeft = startLeft - dx;
      }

      function onUp() {
        if (!active) return;
        active = false;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);

        if (!moved) return;
        el.classList.remove('is-dragging');
        /* swallow only the click that ends a real drag */
        el.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        }, { capture: true, once: true });
      }

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('.sw-zoom')) return;
        active = true;
        moved = false;
        startX = e.clientX;
        startLeft = el.scrollLeft;
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('pointercancel', onUp);
      });
    }

    root.querySelectorAll('.cswatch-grid, .cshape-grid, .ccolor-grid').forEach(enableDrag);

    /* Show the chosen value next to the field label: "STYLE OF STRAP * — Classic" */
    /*
      Writing the answer beside the question earns its place on the fields where the answer is
      otherwise unreadable: a rail of style cards or a palette of thread colours marks the chosen one
      with a border and nothing else, so the label is the only place its NAME appears — and the name
      is what the order records.

      A `<select>` is not one of those. The control displays its own value, in a box a line below, so
      writing it into the label printed the same word twice within 40px of itself. Side by side in a
      pair — "STRAP FORM: Padded" over a box reading "Padded" — it read as a fault rather than a
      flourish, and on the longer label it pushed the guide link onto a second line, which left the
      two columns of the row at different heights.

      One select is the exception, and it proves the rule rather than bending it: the gate on a
      palette. "Stitch Colour" reads "Custom colour (choose below)", which says a choice was made,
      not which — the colour itself is a highlighted swatch further down and appears nowhere as a
      word. That one writes its answer beside the label, through `bindPalette`, into the slot this
      same helper builds.

      Neither kind repeats the INSTRUCTION. "Select thickness", "Pick a form first" live in the
      placeholder, where script keeps them current; the copy beside the label never updated, so
      after choosing a form the field went on telling the customer to choose one.
    */
    function ensureHint(field) {
      var hint = field.querySelector('.hint');
      if (hint) return hint;
      var host = field.querySelector('.cfield__labelrow') || field.querySelector('.cfield__label');
      if (!host) return null;
      hint = document.createElement('span');
      hint.className = 'hint';

      /* Before the guide link, never after it. The link is pinned to the right edge by
         `margin-left: auto`, so anything appended behind it has nowhere left to go and spills
         out of the card — which is exactly what "24/22 mm" was doing on a phone. */
      var help = host.querySelector('.cfield__guides, .chelp');
      if (help) host.insertBefore(hint, help);
      else host.appendChild(hint);
      return hint;
    }

    /*
      Every field writes its answer beside its label — "STRAP LENGTH: XS/S — 100/60 mm" — selects
      included. The owner chose this deliberately, twice: the label line is what a customer scans
      when they read the order back, and one running line of question-and-answer reads faster than
      matching twenty labels to twenty boxes below them. The value appearing in the select as well
      is accepted, not a fault to engineer away.

      A value cleared by a rebuild (thickness after a form change, kind after a skin change) clears
      the copy too — the toggle handles both directions.
    */
    function syncFieldHint(field) {
      if (!field) return;
      var val = '';
      var sel = field.querySelector('select:not(.cchon-phu)');   /* 14/10: bo qua dropdown phu (cstrap-chonphu.js) — nhan doc o radio THAT (co ca gia "(+$5)") */
      if (sel) {
        val = sel.value;
        /* 01/10 (chu shop): Curved End hien CHU khach thay ("Yes" / "No" / "Yes (+$15)"), khong phai value */
        if (val && /-curved-end$/.test(sel.id || '')) { var oc = sel.options[sel.selectedIndex]; if (oc && oc.textContent.trim()) val = oc.textContent.trim(); }
        /* 21/09 chieu (chu shop): Kind echo ca gia nhu chu trong o — "Epsom Calfskin ($75)"; value van la ten tran (don hang, preview, bien the). */
        if (val && /-kind-of-leather$/.test(sel.id || '')) { var ot = sel.options[sel.selectedIndex]; ot = ot ? ot.textContent.trim() : ''; if (ot.indexOf(val) === 0) val = ot; }
        /* 08/10 16:05: Length hien chu option khach thay ("16 cm wrist — 115/70 mm"); gia tri gui gio van "M — 115/70 mm" */
        if (val && /-length$/.test(sel.id || '') && !/^custom size/i.test(val)) { var oL = sel.options[sel.selectedIndex]; if (oL && oL.textContent.trim()) val = oL.textContent.replace(/\s+/g, ' ').trim().replace(/\s*\u2014\s*wrist\b.*$/i, ''); }   /* 22:56: nhan chi lap so \"115/75 mm\" */
        if (/^custom size/i.test(val)) { var gs = window.CSTRAP_SIZE ? CSTRAP_SIZE.giaTri(SID, /-lug-width$/.test(sel.id || '') ? 'lug' : 'len') : ''; val = gs || 'Custom size'; }   /* 20:47: tieu de "LUG WIDTH (mm): 20 / 18 mm" */   /* 07/10: gia tri van "Custom size (enter below)"; chu hien = so khach go (hop le) */
      } else {
        var checked = field.querySelector('input[type="radio"]:checked');
        if (checked && !checked.disabled) {
          val = checked.getAttribute('data-label') || checked.value;   /* 14/10: chu hien thi rieng (khoa Tank: "Tank Deployant — Silver"); value gio giu nguyen */
          var lb = checked.closest('label');
          var plus = lb && lb.querySelector('.sw-plus');
          if (plus && plus.textContent.trim()) val += ' (' + plus.textContent.trim() + ')';
        }
      }

      /* 10/10 P4 (chu shop): nhan Strap Form kem do day dang chon — "Padded Domed \u2014 4.5 mm" (chua chon do day / Request custom -> chi ten form). */
      if (val && sel && /-strap-form$/.test(sel.id || '') && thickSel && thickSel.value && !/^request/i.test(thickSel.value)) val += ' \u2014 ' + thickSel.value;

      var hint = field.querySelector('.hint');
      if (!val) {
        if (hint) { hint.textContent = ''; hint.classList.remove('is-picked'); }
        return;
      }
      hint = ensureHint(field);
      if (!hint) return;
      hint.textContent = val;
      hint.classList.add('is-picked');
    }

    function syncAllHints() {
      root.querySelectorAll('.cfield').forEach(syncFieldHint);
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.tagName === 'SELECT' || t.type === 'radio') {
        syncFieldHint(t.closest('.cfield'));
        if (typeof updateSummary === 'function') updateSummary();
      } else if (t.type === 'file') {
        /* File inputs only ever fire change — without this the photo never reaches the summary. */
        if (typeof updateSummary === 'function') updateSummary();
      }
    });

    /* A "Custom size" choice reveals a text box that must then be filled in */
    function bindCustomSize(selectId, boxId) {
      var sel = document.getElementById(selectId);
      var box = document.getElementById(boxId);
      if (!sel || !box) return;

      function sync() {
        var on = sel.value.slice(0, 6) === 'Custom';
        box.hidden = !on;
        box.querySelectorAll('input').forEach(function (el) {
          /* disabled inputs are neither submitted nor validated, so a hidden
             box never blocks the form and never leaks into the order */
          el.disabled = !on;
          el.required = on;
          if (!on) el.value = '';
        });
        if (typeof updateSummary === 'function') updateSummary();
      }

      sel.addEventListener('change', sync);
      sync();
    }

    bindCustomSize('cf-' + SID + '-lug-width', 'ccustom-lug-' + SID + '');
    bindCustomSize('cf-' + SID + '-length', 'ccustom-len-' + SID + '');
    if (window.CSTRAP_SIZE) CSTRAP_SIZE.gan(root, SID, syncFieldHint);   /* 08/10: o size tu go dung chung V1 + V2 (assets/cstrap-size.js) */

    /* 21/09 (chu shop): o Note cao bang o Engraving (rows=1), tu gian theo noi dung khi go — chi lon len, khong co lai (khach keo tay
       to hon thi giu). scrollHeight da gom padding; cong vien 2 canh vi box-sizing border-box. */
    (function tuGianNote() {
      var ta = root.querySelector('textarea[name="properties[Note]"]');
      if (!ta) return;
      function gian() {
        try {
          var bd = (parseFloat(getComputedStyle(ta).borderTopWidth) || 0) + (parseFloat(getComputedStyle(ta).borderBottomWidth) || 0);
          var can = ta.scrollHeight + bd;
          if (can > ta.clientHeight + bd + 1) ta.style.height = can + 'px';
        } catch (e) { if (window.console) console.warn('tuGianNote loi:', e); }
      }
      ta.addEventListener('input', gian);
      if (ta.value) gian();
    })();

    /* Thickness options depend on whether the strap is flat or padded */
    var formSel = document.getElementById('cf-' + SID + '-strap-form');
    var thickSel = document.getElementById('cf-' + SID + '-thickness');
    var thickBox = document.getElementById('ccustom-thk-' + SID + '');
    var thickData = document.getElementById('cstrap-thickness-' + SID + '');

    /* 10/10 P4 (chu shop): bam o Thickness khi CHUA chon Strap Form -> khong khoa im lang: cuon toi Strap Form + dong "Please select strap form first."
       duoi o Thickness. Khoa bang class .is-needs-form (pointer-events: none -> cu bam roi xuong .cfield, khong mo dropdown rong) + chan phim. */
    var thickField = thickSel ? thickSel.closest('.cfield') : null;
    var formField = formSel ? formSel.closest('.cfield') : null;
    function canForm() { return !!(formSel && thickSel && !formSel.value); }
    function nhacChonForm() {
      if (!thickField) return;
      thickField.classList.add('has-error');
      var l = errLine(thickField);
      l.textContent = 'Please select strap form first.';
      if (!l.id) l.id = 'cerrline-' + SID + '-thk';
      thickSel.setAttribute('aria-describedby', l.id);
      /* 11/10 toi (sep): to DO ca o Strap form (khach hieu ngay phai chon o nao truoc) */
      if (formField) { formField.classList.add('has-error'); var lf = errLine(formField); lf.textContent = 'Please select a strap form.'; lf.dataset.chonForm = '1'; }
      if (formField) diToiThieu({ field: formField, focus: null });
    }
    function capNhatKhoaThick() {
      if (!thickSel) return;
      var can = canForm();
      thickSel.classList.toggle('is-needs-form', can);
      if (!can && thickField) {
        thickField.classList.remove('has-error');
        var l = thickField.querySelector('.cfield__err');
        if (l) l.textContent = '';
        thickSel.removeAttribute('aria-describedby');
        var lf2 = formField && formField.querySelector('.cfield__err');
        if (lf2 && lf2.dataset.chonForm) { lf2.textContent = ''; delete lf2.dataset.chonForm; formField.classList.remove('has-error'); }
      }
    }
    if (thickField) {
      thickField.addEventListener('click', function (e) {
        if (!canForm()) return;
        var r = thickSel.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
        e.preventDefault();
        nhacChonForm();
      });
      thickSel.addEventListener('keydown', function (e) {
        if (!canForm()) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); nhacChonForm(); }
      });
    }

    function syncCustomThickness() {
      if (!thickBox || !thickSel) return;
      var on = thickSel.value.slice(0, 7) === 'Request';
      thickBox.hidden = !on;
      thickBox.querySelectorAll('input').forEach(function (el) {
        el.disabled = !on;
        el.required = on;
        if (!on) el.value = '';
      });
      updateSummary();
    }

    if (formSel && thickSel && thickData) {
      var THICK = JSON.parse(thickData.textContent);

      var buildThickness = function () {
        var pamList = (window.CSTRAP_PAM && window.CSTRAP_PAM.thickness(root, formSel.value)) || (window.CSTRAP_APW && window.CSTRAP_APW.thickness(root, formSel.value));   /* 23/10: Apple Watch dung chung co che do day cua PAM */
        var list = pamList || THICK[formSel.value] || THICK[/^Padded/.test(formSel.value) ? 'Padded' : ''] || [];   /* 09/10: 3 dang Padded = danh sach Padded */
        thickSel.innerHTML = '';

        var ph = document.createElement('option');
        ph.value = '';
        ph.disabled = true;
        ph.selected = true;
        ph.textContent = list.length ? 'Select thickness' : 'Pick a form first';   /* 09/10 chu shop: tra ve chu cu */
        thickSel.appendChild(ph);

        list.forEach(function (t) {
          var opt = document.createElement('option');
          opt.value = pamList ? t.value : t;
          opt.disabled = pamList ? t.disabled : false;
          opt.textContent = pamList ? (t.label || t.value) + (t.disabled ? ' (not available for this padding)' : '') : t;
          thickSel.appendChild(opt);
        });

        syncCustomThickness();
        syncFieldHint(thickSel.closest('.cfield'));
        syncFieldHint(formField);
        capNhatKhoaThick();
        updateSummary();
      };

      formSel.addEventListener('change', buildThickness);
      thickSel.addEventListener('change', syncCustomThickness);
      thickSel.addEventListener('change', function () { syncFieldHint(formField); });   /* 10/10 P4: nhan Strap Form kem do day */

      /* Build it once on load, too. Strap Form has no "Select…" placeholder — it opens already
         resting on Flat — so a customer who is happy with Flat never fires a change event, and the
         thickness list was only ever built for people who changed their mind. Everyone else met an
         empty select that said "Pick a form first" about a form that was already picked. */
      buildThickness();
    }

    /* 16/09/2026: "(recommended)" la ghi chu cho LUC CHON, khong phai thu di vao gio va don.
       No dang nam trong VALUE cua option (section dat `stitch_gates = 'Cream (recommended),...'`),
       nen di thang vao property. Don o day — doi value, GIU nguyen chu hien ra — vi:
         - sua trong section thi phai them quy uoc "value|nhan" cho `cstrap-select`, ma snippet
           do dung chung cho hang chuc o khac -> dong cham lon;
         - loc luc gui thi chi vá duoc duong AJAX (co cart drawer); duong POST thuong (khong co
           drawer) van mang chu do di.
       Doi value ngay tu dau thi ca hai duong deu sach, va cac cho so khop TIEN TO ('Cream',
       'Match leather', 'Custom') trong engine van dung nhu cu. */
    (function donGhiChuChon() {
      var HAU = / \(recommended\)\s*$/;
      var lam = function () {
        var os = document.querySelectorAll('.cstrap select option, select[id*="-stitch-colour"] option, select[id*="-edge-colour"] option, select[id*="-keeper-colour"] option');
        for (var i = 0; i < os.length; i++) {
          var o = os[i];
          if (HAU.test(o.value)) {
            if (o.textContent === o.value) o.textContent = o.value;   /* nhan giu nguyen chu */
            o.value = o.value.replace(HAU, '');
          }
        }
      };
      lam();
      document.addEventListener('DOMContentLoaded', lam);
    })();

    /* A palette that only appears when its select says "Custom colour". Stitch and edge ask the
       same question about two parts of the strap, so they share the one function rather than two
       copies that drift apart the first time either is touched. */
    function bindPalette(selectId, boxId) {
      var sel = document.getElementById(selectId);
      var box = document.getElementById(boxId);
      if (!sel || !box) return;

      /*
        Once the palette is open, the select itself stops being an answer and goes back to being the
        question. Left named, the order carried both lines — "Stitch Colour: Custom colour (choose
        below)" above "Thread Colour: Burgundy" — and the first is an instruction to press a button,
        addressed to a customer who has already pressed it. The workshop reads it as a specification
        and has to work out which of the two lines to believe.

        So the gate submits only while it is the answer. Taking the name off rather than disabling
        the field keeps it in the tab order and keeps `required` working, so validation is untouched.
      */
      var gateName = sel.getAttribute('name');

      var dungBang = function () {
        var t = box.querySelector('template');
        if (!t || t.parentNode !== box) return;
        box.insertBefore(t.content.cloneNode(true), t);
        box.removeChild(t);
      };

      var sync = function () {
        /* 03/10: Keeper doi ten nut -> "One colour" / "Two colours" cung mo bang mau nhu "Custom ..." */
        var custom = sel.value.slice(0, 6) === 'Custom' || /^(one|two) colou?rs?$/i.test(sel.value);
        if (custom) dungBang();
        box.hidden = !custom;
        if (gateName) {
          if (custom) sel.removeAttribute('name');
          else sel.setAttribute('name', gateName);
        }
        var radios = box.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          /* disabled inputs are not submitted, so a hidden palette stays out of the order */
          radios[i].disabled = !custom;
          radios[i].required = custom && i === 0;
          if (!custom) radios[i].checked = false;
        }
        /*
          Closing the palette clears the colour written beside the label with it. The radios are
          unchecked above, so the answer no longer exists — leaving the word there would have the
          field claiming a colour the order does not carry, which is the one kind of wrong a summary
          must never be.
        */
        if (!custom) {
          var gateField = sel.closest('.cfield');
          var stale = gateField && gateField.querySelector('.hint');
          if (stale) { stale.textContent = ''; stale.classList.remove('is-picked'); }
        }
        updateSummary();
      };
      sel.addEventListener('change', sync);
      sync();

      /* The colour the customer picked belongs at the top of the field, beside its name — that is
         where every other field writes its answer, and it is the line they scan when checking the
         order. Left alone, the top line keeps reading "Custom colour (choose below)", which is an
         instruction, not an answer: the field ends up telling them to do the thing they have just
         done. The palette's own heading is where they are looking least, because they are looking
         at the swatch they just clicked. */
      box.addEventListener('change', function (e) {
        var radio = e.target;
        if (!radio || radio.type !== 'radio' || !radio.checked) return;
        var field = sel.closest('.cfield');
        /*
          Built on demand rather than looked up. Selects no longer ship a hint of their own — the
          control speaks for itself — but this one cannot: it reads "Custom colour (choose below)",
          which says a choice was made, not which. So the slot is created the first time a swatch is
          clicked, and only on the gates that need it.
        */
        var hint = field && ensureHint(field);
        if (!hint) return;
        hint.textContent = radio.value;
        hint.classList.add('is-picked');
      });
    }

    (function () {
      var box = root.querySelector('.cqty');
      if (!box) return;
      var inp = box.querySelector('input');
      box.querySelectorAll('.cqty__btn').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(inp.value, 10) || 1;
          v += parseInt(b.getAttribute('data-qty'), 10);
          inp.value = Math.min(20, Math.max(1, v));
        });
      });
    })();

    if (CFG.showPhoto) {
    (function () {
      var tick = document.getElementById('cf-unsure-' + SID + '');
      var box = document.getElementById('cupload-' + SID + '');
      var drop = document.getElementById('cdrop-' + SID + '');
      if (!tick || !box || !drop) return;
      tick.addEventListener('change', function () { box.hidden = !tick.checked; });

      var inputs = Array.prototype.slice.call(drop.querySelectorAll('input[type="file"]'));
      var list = drop.querySelector('.cdrop__list');
      var MAX = 18 * 1024 * 1024;
      var OK = /\.(heic|jpe?g|gif|png|pdf)$/i;

      function slotTrong() { return inputs.filter(function (i) { return !i.files.length; })[0]; }

      function ve() {
        list.innerHTML = '';
        inputs.forEach(function (inp) {
          if (!inp.files.length) return;
          var li = document.createElement('li');
          var f = inp.files[0];
          li.textContent = f.name + ' (' + (f.size / 1048576).toFixed(1) + ' MB) ';
          var x = document.createElement('button');
          x.type = 'button'; x.className = 'cdrop__rm'; x.textContent = '×';
          x.setAttribute('aria-label', 'Remove ' + f.name);
          x.addEventListener('click', function () { inp.value = ''; ve(); });
          li.appendChild(x);
          list.appendChild(li);
        });
      }

      function nhan(files) {
        Array.prototype.slice.call(files).forEach(function (f) {
          var slot = slotTrong();
          if (!slot) { alert('Maximum 3 files.'); return; }
          if (!OK.test(f.name)) { alert(f.name + ': only heic, jpg, gif, png or pdf.'); return; }
          if (f.size > MAX) { alert(f.name + ' is over 18 MB.'); return; }
          var dt = new DataTransfer();
          dt.items.add(f);
          slot.files = dt.files;
        });
        ve();
      }

      drop.querySelector('.cdrop__btn').addEventListener('click', function () {
        var slot = slotTrong();
        if (slot) slot.click(); else alert('Maximum 3 files.');
      });
      inputs.forEach(function (inp) {
        inp.addEventListener('change', function () {
          /* Chon qua hop thoai: file da nam dung slot, chi can soat lai + ve. */
          if (inp.files.length) {
            var f = inp.files[0];
            if (!OK.test(f.name) || f.size > MAX) {
              alert(!OK.test(f.name) ? f.name + ': only heic, jpg, gif, png or pdf.' : f.name + ' is over 18 MB.');
              inp.value = '';
            }
          }
          ve();
        });
      });
      ['dragover', 'dragenter'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
      });
      drop.addEventListener('drop', function (e) { nhan(e.dataTransfer.files); });
    })();
    }

    bindPalette('cf-' + SID + '-stitch-style', 'cstitchstyle-custom-' + SID + '');
    bindPalette('cf-' + SID + '-stitch-colour', 'cstitch-custom-' + SID + '');
    bindPalette('cf-' + SID + '-edge-colour', 'cedge-custom-' + SID + '');
    bindPalette('cf-' + SID + '-keeper-colour', 'ckeeper-custom-' + SID + '');
    bindPalette('cf-' + SID + '-underlay-colour', 'cunderlay-custom-' + SID + '');

    /* ---- Ban thu nghiem v2: chi chay khi template bat cong tac, mac dinh tat ---- */

    /* 1. Bat khach tu chon co. Hang lam theo yeu cau khong doi tra duoc, nen mot con so
          dien san ma khach luot qua la mot cai day khong lap vua. */
    if (CFG && CFG.requireSize) {
      (function () {
        var CAN = ['Lug Width', 'Length'];
        var nut = root.querySelector('.cstrap__add');
        if (!nut) return;

        var loi = document.createElement('p');
        loi.className = 'cstrap__v2loi';
        loi.hidden = true;
        if (nut.parentNode) nut.parentNode.insertBefore(loi, nut.nextSibling);

        function thieu() {
          var ds = [];
          for (var i = 0; i < CAN.length; i++) {
            var s = root.querySelector('select[name="properties[' + CAN[i] + ']"]');
            if (s && !s.value) ds.push(s);
          }
          return ds;
        }
        function ve() {
          var ds = thieu();
          nut.disabled = ds.length > 0;
          nut.classList.toggle('is-khoa', ds.length > 0);
          if (!ds.length) { loi.hidden = true; return; }
          var ten = ds.map(function (s) {
            var f = s.closest('.cfield');
            var l = f && (f.querySelector('.cfield__label') || f.querySelector('label'));
            return (l ? l.textContent : '').replace(/[*:].*$/, '').replace(/\s+/g, ' ').trim();
          });
          loi.textContent = 'Chon ' + ten.join(' va ') + ' truoc khi them vao gio.';
          loi.hidden = false;
        }
        /* Xoa gia tri dien san — cong tac nay ton tai chinh de khach phai tu chon. */
        CAN.forEach(function (t) {
          var s = root.querySelector('select[name="properties[' + t + ']"]');
          if (!s) return;
          var ph = s.querySelector('option[value=""]');
          if (!ph) {
            ph = document.createElement('option');
            ph.value = ''; ph.disabled = true;
            ph.textContent = 'Select ' + t.toLowerCase();
            s.insertBefore(ph, s.firstChild);
          }
          s.value = '';
          s.dispatchEvent(new Event('change', { bubbles: true }));
          s.addEventListener('change', ve);
        });
        root.addEventListener('change', ve);
        ve();
      })();
    }

    /* 2. Gom cac o it dung vao mot khoi dong. Lam bang JS chu khong cat ghep Liquid:
          7 o nay nam rai tu dong 784 den 1255, sua markup la rui ro that su. */
    if (CFG && CFG.groupAdvanced) {
      (function () {
        var TEN = ['Curved End', 'Strap form', 'Thickness', 'Stitch Style', 'Stitch Colour',
                   'Edge colour', 'Engraving'];
        var o = [];
        TEN.forEach(function (t) {
          var e = root.querySelector('[name="properties[' + t + ']"]');
          var f = e && e.closest('.cfield');
          if (f && o.indexOf(f) === -1) o.push(f);
        });
        if (o.length < 2) return;

        var hop = document.createElement('details');
        hop.className = 'cstrap__v2hop';
        var dau = document.createElement('summary');
        dau.className = 'cstrap__v2dau';
        dau.textContent = 'Tuy chinh them (' + o.length + ')';
        hop.appendChild(dau);

        o[0].parentNode.insertBefore(hop, o[0]);
        o.forEach(function (f) { hop.appendChild(f); });
      })();
    }

    /* Engraving va Note dung <label> tran, khong co .cfield__label, nen syncFieldHint
       bo qua chung — hai o duy nhat khong in cau tra loi ra canh nhan. */
    ['Engraving', 'Note'].forEach(function (ten) {
      var o = root.querySelector('[name="properties[' + ten + ']"]');
      var field = o && o.closest('.cfield');
      var lab = field && field.querySelector('label');
      if (!lab) return;
      var opt = lab.querySelector('.opt');
      var hint = document.createElement('span');
      hint.className = 'hint';
      lab.appendChild(hint);
      function ve() {
        var v = (o.value || '').trim();
        if (v.length > 28) v = v.slice(0, 28) + '…';
        hint.textContent = v;
        hint.classList.toggle('is-picked', !!v);
        if (opt) opt.style.display = v ? 'none' : '';
        lab.classList.toggle('is-filled', !!v);
      }
      o.addEventListener('input', ve);
      o.addEventListener('change', ve);
      ve();
    });

    (function () {
      var FULL = 'As Pictured (same as product photo)';
      root.querySelectorAll('select').forEach(function (sel) {
        var opt = Array.prototype.slice.call(sel.options).filter(function (o) { return o.value === 'As Pictured'; })[0];
        if (opt) opt.textContent = FULL;
      });
    })();
    /*
      bindPalette marks the first swatch of a palette it opens as required. Right for stitch and
      edge, wrong here: the pair is one answer and either loop alone is a complete one, so requiring
      the upper loop would refuse an order that colours only the lower.
    */
    (function () {
      var box = document.getElementById('ckeeper-custom-' + SID + '');
      if (!box) return;
      var clear = function () {
        var rs = box.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < rs.length; i++) rs[i].required = false;
      };
      clear();
      box.addEventListener('change', clear);
      var gate = document.getElementById('cf-' + SID + '-keeper-colour');
      if (gate) gate.addEventListener('change', function () { requestAnimationFrame(clear); });
    })();

    /*
      2026-08-25: bo cong !CFG.livePreview khoi RIENG doan an dia thu 2.
      Tren trang co live preview, strap-form-preview.js cung lo viec nay — nhung no
      tim hop ckeeper2 TRUOC luc bang mau duoc nhan ban tu <template>, tim khong ra
      roi khong chay lai. Ket qua: chon "Custom - one colour" van hien ca hai dia.
      Doan duoi tim lai hop trong TUNG lan change nen bit duoc cho do, va no chay
      SAU bindPalette nen luc no chay thi hop da ton tai.
      Hai ben tinh cung mot luat haiMau nen khong da nhau.
      chainRally van nam trong cong cu: no dung lai luoi theo loai da, de chay tren
      trang preview se da voi buildKeeperGrid cua preview.
    */
    (function () {
      var gate = document.getElementById('cf-' + SID + '-keeper-colour');
      if (!gate) return;
      var sync = function () {
        /* Hai bang mau nam trong <template>, chi duoc nhan ban khi khach mo palette. Tim tu luc
           tai trang thi luon null va ca doan nay bo chay — dia thu 2 khong bao gio bi an. */
        var two = document.getElementById('ckeeper2-custom-' + SID + '');
        if (!two) return;
        var haiMau = /(different colour on each|two colours)/i.test(gate.value);
        two.hidden = !haiMau;
        var rs = two.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < rs.length; i++) {
          rs[i].disabled = !haiMau;
          if (!haiMau) rs[i].checked = false;
        }
        var l1 = document.querySelector('[id^="ckeeper1-box-"] .cfield__label');
        if (l1 && l1.firstChild) {
          var ten = haiMau ? 'Up loop' : 'Keeper colour - both loops';
          if ((l1.firstChild.nodeValue || '').trim() !== ten) l1.firstChild.nodeValue = ten;
        }
      };
      sync();
      gate.addEventListener('change', sync);
    })();

    if (!CFG.livePreview) {
    if (CFG.chainRally) {
    (function () {
      var uf = document.getElementById('cunderlay-field-' + SID + '');
      var kf = document.getElementById('ckeeper-field-' + SID + '');
      var kGate = document.getElementById('cf-' + SID + '-keeper-colour');
      var data = null;
      try { data = JSON.parse(document.getElementById('cstrap-leather-' + SID + '').textContent); } catch (e) {}

      function styleNow() {
        var r = root.querySelector('input[name="properties[Style of Strap]"]:checked');
        return r ? r.value : '';
      }
      function kindNow() {
        var ss = root.querySelectorAll('select');
        for (var i = 0; i < ss.length; i++) if (ss[i].name === 'properties[Kind of Leather]') return ss[i].value;
        return '';
      }

      function rebuildKeeper() {
        if (!data || !data.colors) return;
        var kind = kindNow();
        var list = data.colors[kind];
        if (!list) return; /* chua chon da -> giu bang trim mac dinh */
        var props = ['Custom Keeper Colour', 'Custom Keeper 2 Colour'];
        var boxes = ['ckeeper1-box-' + SID + '', 'ckeeper2-custom-' + SID + ''];
        for (var b = 0; b < 2; b++) {
          var grid = document.getElementById(boxes[b]);
          grid = grid && grid.querySelector('.ccolor-grid');
          if (!grid) continue;
          var html = '';
          for (var i = 0; i < list.length; i++) {
            var c = list[i];
            var hex = (data.palette && (data.palette[kind + '::' + c] || data.palette[c])) || '#9a9a9a';
            html += '<label class="ccolor" title="' + c + '" data-hex="' + hex + '">' +
              '<input type="radio" name="properties[' + props[b] + ']" value="' + c + '">' +
              '<span class="ccolor__tile ccolor__tile--thread" style="--c: ' + hex + '"></span>' +
              '<span class="ccolor__n">' + c + '</span></label>';
          }
          grid.innerHTML = html;
        }
        /* de bindPalette dat lai disabled/required theo trang thai gate hien tai */
        if (kGate) kGate.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function sync() {
        var on = /^(PAM )?(Micro Rally|Hybrid Rally)$/.test(styleNow());   /* 23/10: them PAM Micro / Hybrid Rally */
        if (uf) {
          uf.style.display = on ? '' : 'none';
          var rs = uf.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < rs.length; i++) { rs[i].disabled = !on; if (!on) rs[i].checked = false; }
        }
        if (kf) {
          kf.style.display = on ? '' : 'none';
          if (kGate) {
            kGate.disabled = !on;
            if (!on) { kGate.selectedIndex = 0; kGate.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        }
      }

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.name) return;
        if (t.name === 'properties[Style of Strap]') sync();
        if (t.name === 'properties[Kind of Leather]') rebuildKeeper();
      });
      sync();
      rebuildKeeper();
    })();
    }
    }

    /*
      Cap the leather chart at three whole rows. The height is READ OFF THE CARDS — the top of the
      thirteenth minus the top of the first, less one row gap — never a number in the stylesheet.
      A guessed height is what cut "Cognac Brown" down to "Cognac" the last time this grid was
      boxed: the cards change height with the column width, so any fixed cap is wrong at some
      width. Measured, the cut always lands in the gap between rows.

      Re-measured whenever the grid is rebuilt (a new leather brings a new palette) and whenever the
      window resizes, because both change the row height.
    */
    /* Tu 14/09 co hai luoi (da + lot da) cung tien to id — tran ap cho tung luoi, khong chi luoi dau. */
    function capLeatherGrid() {
      document.querySelectorAll('#cstrap-' + SID + ' [id^="cstrap-color-"] .ccolor-grid').forEach(capOneGrid);
    }
    /* 11/10 DOT 3 (chu shop): TAT HAN cap chieu cao bang JS. Luoi mau da / lot da la KHUNG CUON do CSS quyet dinh chieu cao
       (PC: ~2,8 hang do script cuoi file; mobile: 2 hang vuot ngang, cao tu nhien). Do kieu cu (o thu 13 tru o dau) tren luoi 2 hang
       xep theo cot cho hieu ~0 -> max-height 18px, khach khong bam duoc mau. Chi con GO dau vet cu neu co. */
    function capOneGrid(grid) {
      if (!grid) return;
      if (grid.style.maxHeight) grid.style.maxHeight = '';
      if (grid.classList.contains('is-capped')) grid.classList.remove('is-capped');
    }
    capLeatherGrid();
    /* 10/10 P4: gop thanh 1 lan / khung hinh, chay SAU ve (truoc day moi dot mutation = 1 rAF chen vao khung hinh, doc layout bat buoc) */
    var _capCho = false;
    function capLeatherGridGop() {
      if (_capCho) return;
      _capCho = true;
      requestAnimationFrame(function () { setTimeout(function () { _capCho = false; capLeatherGrid(); }, 0); });
    }
    window.addEventListener('resize', capLeatherGridGop);
    if (window.MutationObserver) {
      var _capObs = new MutationObserver(capLeatherGridGop);
      document.querySelectorAll('#cstrap-' + SID + ' [id^="cstrap-color-"]').forEach(function (box) {
        _capObs.observe(box, { childList: true, subtree: true });
      });
    }
    /* Photographs settle after their images decode, which moves every row below them. */
    window.addEventListener('load', capLeatherGrid);

    /* 21/09 (chu shop): rail cuon ngang an thanh cuon (CSS) -> bao "con noi dung ben phai" bang vet mo: lop is-con-phai khi
       scrollLeft + clientWidth < scrollWidth (mask-image trong custom-strap-form.css, --rail-fade). Do lai khi cuon (capture: scroll
       khong noi bot), resize, luoi doi kich co (ResizeObserver) hay truong hien/an (MutationObserver). Bang mau PC cap 3 hang
       (.is-capped) cuon doc: khong cuon ngang nen tu khong mo. */
    var RAIL_SEL = '#cstrap-' + SID + ' .ccolor-grid, #cstrap-' + SID + ' .cswatch-grid, #cstrap-' + SID + ' .cshape-grid';
    function capRail(el) {
      var con = el.scrollWidth > el.clientWidth + 2 && el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
      if (el.classList.contains('is-con-phai') !== con) el.classList.toggle('is-con-phai', con);
    }
    function capMoiRail() {
      try {
        /* 11/10 LAG B2/E1: doc het (1 lan dan trang) roi moi ghi class — truoc: doc/ghi xen ke moi rail = nhieu lan dan trang. */
        var rs = document.querySelectorAll(RAIL_SEL), kq = [];
        for (var i = 0; i < rs.length; i++) { var el = rs[i]; kq.push(el.scrollWidth > el.clientWidth + 2 && el.scrollLeft + el.clientWidth < el.scrollWidth - 2); }
        for (var j = 0; j < rs.length; j++) { if (rs[j].classList.contains('is-con-phai') !== kq[j]) rs[j].classList.toggle('is-con-phai', kq[j]); }
      }
      catch (e) { if (window.console) console.warn('capMoiRail loi:', e); }
    }
    document.addEventListener('scroll', function (e) { var t = e.target; if (t && t.matches && t.matches(RAIL_SEL)) capRail(t); }, true);
    var _railCho = false;
    function capMoiRailGop() {
      if (_railCho) return;
      _railCho = true;
      requestAnimationFrame(function () { setTimeout(function () { _railCho = false; capMoiRail(); }, 0); });
    }
    window.addEventListener('resize', capMoiRailGop);
    window.addEventListener('load', capMoiRail);
    capMoiRail();
    /* 11/10 LAG B2/E1: bo theo doi attributes (hidden/class/style) tren CA section — moi lan engine/preview ghi 1 class/style la do lai moi rail
       (90-215 ms/bam, va chinh 'is-con-phai' lai kich hoat no). Rail an/hien doi kich co -> ResizeObserver bat; chi con childList de bat rail MOI sinh ra. */
    var _railRo = null;
    function nhoRail() {
      if (!_railRo) return;
      document.querySelectorAll(RAIL_SEL).forEach(function (el) { if (!el.__railRo) { el.__railRo = 1; _railRo.observe(el); } });
    }
    if (window.ResizeObserver) { _railRo = new ResizeObserver(capMoiRailGop); nhoRail(); }
    if (window.MutationObserver) {
      var _railObs = new MutationObserver(function () { nhoRail(); capMoiRailGop(); });
      var _sec = document.getElementById('cstrap-' + SID);
      if (_sec) _railObs.observe(_sec, { childList: true, subtree: true });
    }

    /*
      Both loops' answers ride on the gate's own hint line, where every other field writes its
      answer - one line reading "Keeper 1 Red - Keeper 2 Black", so a customer scrolling back sees
      what the pair is set to without hunting through two palettes.
    */
    function syncKeeperEcho() {
      var gate = document.getElementById('cf-' + SID + '-keeper-colour');
      var field = gate && gate.closest('.cfield');
      if (!field) return;
      function picked(prop) {
        var r = document.querySelector('input[name="properties[' + prop + ']"]:checked');
        return (r && !r.disabled) ? r.value : null;
      }
      var k1 = picked('Custom Keeper Colour'), k2 = picked('Custom Keeper 2 Colour');
      if (!k1 && !k2) return;
      var hint = ensureHint(field);
      if (!hint) return;
      var haiMau = /(different colour on each|two colours)/i.test(gate.value);
      if (!haiMau) {
        hint.textContent = k1 || k2 || '';
      } else {
        hint.textContent = 'Up: ' + (k1 || 'match leather') + ' \u00b7 Down: ' + (k2 || 'match leather');
      }
      hint.classList.add('is-picked');
    }
    document.getElementById('cstrap-' + SID + '').addEventListener('change', syncKeeperEcho);
    syncKeeperEcho();

    /*
      A strap with no stitching has no thread, so there is no thread colour to choose. Left on show,
      the field asks the customer to pick the colour of something they have just said they do not
      want — and worse, it lets them answer, so the order arrives at the workshop specifying Burgundy
      thread on a strap that is not to be stitched. Somebody then has to decide which of the two the
      customer meant.

      Hidden AND disabled, deliberately: `hidden` alone still submits the value, and a `required`
      field the customer cannot see would block Add to cart with an error pointing at nothing.
      Disabling does both — out of the order, out of validation.

      The edge colour stays. Edge paint is applied to a cut edge whether or not the strap is stitched.
    */
    var stitchColourSel = document.getElementById('cf-' + SID + '-stitch-colour');
    var stitchColourField = stitchColourSel ? stitchColourSel.closest('.cfield') : null;
    var threadBox = document.getElementById('cstitch-custom-' + SID + '');
    var noStitchWas = null;

    function stitchIsNone() {
      var picked = root.querySelector('input[name="properties[Style of Stitches]"]:checked');
      return !!picked && !picked.disabled && picked.value.indexOf('No Stitches') === 0;
    }

    function syncStitchColour() {
      if (!stitchColourField || !stitchColourSel) return;
      var none = stitchIsNone();
      if (none === noStitchWas) return;
      noStitchWas = none;

      stitchColourField.hidden = none;
      stitchColourSel.disabled = none;

      if (threadBox) {
        if (none) {
          threadBox.hidden = true;
          threadBox.querySelectorAll('input').forEach(function (el) {
            el.disabled = true;
            el.required = false;
            el.checked = false;
          });
        } else {
          /* Hand the palette back to bindPalette rather than second-guessing it: whether the box
             should reopen depends on the select, which is the one thing that knows. */
          stitchColourSel.dispatchEvent(new Event('change'));
        }
      }
      updateSummary();
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'properties[Style of Stitches]' || e.target === document.getElementById('cf-' + SID + '-stitch-style')) {
        syncStitchColour();
      }
    });
    syncStitchColour();

    /* Live summary of everything the customer has picked */
    var sum = document.getElementById('csum-' + SID + '');
    var sumList = sum ? sum.querySelector('.csum__list') : null;
    var nutRut = sum ? sum.querySelector('[data-rut]') : null;
    /* 07/10 (chu shop): khung .csum--gio = KHOP GIO — dong lay tu CHINH bo property gui gio (gomProps -> gonProps), khong luat rieng.
       gomProps gan trong khoi form (noi gonProps / xepThuTuProps / doiKeeper duoc khai). */
    var GIO = !!(sum && sum.classList.contains('csum--gio'));
    var gomProps = null;

    /*
      Bon hang "loi" — nhung gi khach van thay khi khung dang rut. Nhan dien bang NAME cua o,
      KHONG bang nhan: nhan hang mau la nhan dong ("Ostrich Colour", "Lizard Colour"...) do
      chinh JS dung theo loai da dang chon, nen so khop chuoi nhan se hong ngay lan dau shop
      them mot loai da moi.
    */
    var LOI = ['Kind of Leather', 'Colour', 'Lug Width', 'Length'];

    function tenO(field) {
      var e = field && field.querySelector('select[name], input[name], textarea[name]');
      if (!e || !e.name) return '';
      var m = /^properties\[(.*)\]$/.exec(e.name);
      return m ? m[1] : e.name;
    }

    function laHangLoi(field) {
      return LOI.indexOf(tenO(field)) >= 0;
    }

    /*
      Nut chi ton tai khi co viec cho no lam: phai co it nhat mot hang loi de RUT VE, va phai
      co hang khong-loi de GIAU. Thieu mot trong hai thi bam nut khong doi gi ca — mot cai nut
      khong doi gi la mot cai nut hong.
    */
    function capNhatNut() {
      if (!nutRut || !sum || !sumList) return;
      if (GIO) {
        nutRut.hidden = !sumList.children.length;
        var mo = !sum.classList.contains('is-rut');
        nutRut.setAttribute('aria-expanded', mo ? 'true' : 'false');
        nutRut.setAttribute('aria-label', mo ? 'Hide details' : 'View details');
        var c = nutRut.querySelector('.csum__toggle-n');
        if (c) c.textContent = mo ? 'Hide details \u25B4' : 'View details \u25BE';
        return;
      }
      var tong = sumList.children.length;
      var loi = sumList.querySelectorAll('.csum__item--loi').length;
      var an = tong - loi;
      /* Chi can CO gi de giau. Khong doi phai co san hang loi nua: khi khach chua chon gi,
         bang rut lai thanh rong — va mot bang rong dung la thu nen thay o buoc do, thay vi
         sau dong mac dinh khach chua he dong vao. */
      nutRut.hidden = !(an > 0);
      if (nutRut.hidden) return;
      var dangRut = sum.classList.contains('is-rut');
      nutRut.setAttribute('aria-expanded', dangRut ? 'false' : 'true');
      /* Nut nam trong tieu de nen chi con cho cho MOT CON SO. Cau day du van phai co,
         nhung danh cho trinh doc man hinh — no khong can ve ra de chiem cho. */
      nutRut.setAttribute('aria-label',
        dangRut ? ('Show ' + an + ' more options') : 'Show fewer options');
      var chu = nutRut.querySelector('.csum__toggle-n');
      if (chu) chu.textContent = dangRut ? String(an) : '';
    }

    /*
      Go xong thi trang phai o DUNG CHO luc truoc khi go.

      Ban phim iOS mo ra la Safari tu cuon trang de lo o dang go; dong lai thi no khong tra
      ve cho cu, nen khach bam Done xong thay minh dang o mot doan khac. Khong dung den bo cuc
      de chua cai nay — chi ghi lai cho, roi dat lai.
    */
    var yTruocGo = null;      // vi tri cuon luc cham vao o
    var daMoBanPhim = false;  // ban phim THAT SU da tung mo trong luot nay
    var vvKhung = window.visualViewport;

    function laOGoChu(e) {
      if (!e) return false;
      if (e.tagName === 'TEXTAREA') return true;
      if (e.tagName !== 'INPUT') return false;
      var t = (e.type || '').toLowerCase();
      return t === 'text' || t === 'number' || t === 'email' || t === 'tel' || t === 'search' || t === '';
    }

    function traVeCho() {
      if (yTruocGo === null || !daMoBanPhim) return;
      var a = document.activeElement;
      /* Dang chuyen sang mot o khac trong form: trinh duyet cuon toi o do la DUNG. */
      if (a && a !== document.body && root.contains(a)) return;
      var y = yTruocGo;
      yTruocGo = null;
      daMoBanPhim = false;
      /* Lech vai pixel la binh thuong, khong dang giat trang mot cai vi no. */
      if (Math.abs(window.pageYOffset - y) > 8) window.scrollTo(0, y);
    }

    root.addEventListener('focusin', function (e) {
      if (!laOGoChu(e.target)) return;
      if (yTruocGo === null) yTruocGo = window.pageYOffset;
    });

    if (vvKhung) {
      vvKhung.addEventListener('resize', function () {
        if (yTruocGo === null) return;
        /* Vung nhin thap hon han chieu cao bo cuc = ban phim dang chiem cho. */
        if (vvKhung.height < window.innerHeight - 100) { daMoBanPhim = true; return; }
        if (daMoBanPhim) setTimeout(traVeCho, 60);
      });
    }

    /* Duong du phong cho trinh duyet khong co visualViewport. */
    root.addEventListener('focusout', function (e) {
      if (!laOGoChu(e.target)) return;
      setTimeout(traVeCho, 320);
    });

    if (nutRut && sum) {
      /* 12/10 vong 2 (chu shop): mo/dong 1 cho chung. Giu vi tri khung tren man hinh (tru phan lech) de trang KHONG nhay khi bang dai co/gian. */
      var doiRut = function () {
        var y0 = sum.getBoundingClientRect().top;
        /* Class nam tren .csum chu khong tren tung hang: updateSummary() dung LAI ca danh
           sach moi lan khach doi lua chon, nen trang thai gan vao hang se mat ngay. */
        sum.classList.toggle('is-rut');
        capNhatNut();
        var d = sum.getBoundingClientRect().top - y0;
        if (Math.abs(d) > 1) window.scrollBy(0, d);
      };
      nutRut.addEventListener('click', doiRut);
      /* 12/10 vong 2 (chu shop): (1) bam BAT KY cho nao tren hang tieu de (chu "Your strap", khoang trong, mui ten) = mo/dong;
         (2) dang MO: bam bat ky cho nao trong o (chi tiet, bang gia) = DONG, tru phan tu tuong tac (a, button, input, select, textarea, label).
         Chi chay khi nut dang HIEN (dien thoai < 750); may tinh khung luon mo, khong co nut. Nut tu xu ly click cua no (khong dem 2 lan). */
      sum.addEventListener('click', function (e) {
        if (nutRut.hidden || !nutRut.offsetParent || nutRut.contains(e.target)) return;
        if (e.target.closest && e.target.closest('a, button, input, select, textarea, label, summary, [role="button"], [contenteditable]')) return;
        var moDang = !sum.classList.contains('is-rut');
        if (moDang || e.target.closest('.csum__h')) doiRut();
      });
    }

    function fieldLabel(field) {
      var el = field.querySelector('.cfield__label') || field.querySelector('label');
      if (!el) return '';
      var clone = el.cloneNode(true);
      clone.querySelectorAll('.req, .hint, .chelp, .opt, .cfield__colon').forEach(function (n) { n.remove(); });
      return clone.textContent.replace(/\s+/g, ' ').trim().replace(/[:\s]+$/, '').replace(/^Choose\s+/i, '').trim();
    }

    /*
      Four kinds of control live in this form and they do not fail the same way. A leather
      nobody picked is unfinished work; a note nobody wrote is simply a note nobody wrote.
      So the summary reports the value AND what kind of blank it is, and the caller decides
      what to print. Lumping them together is how every row ends up shouting "Not selected".
    */
    function fieldValue(field) {
      var file = field.querySelector('input[type="file"]');
      if (file) {
        var picked = file.files && file.files.length ? file.files[0].name : '';
        return { value: picked, kind: 'file' };
      }

      var area = field.querySelector('textarea');
      if (area) return { value: area.value.trim(), kind: 'note' };

      var sel = field.querySelector('select');
      if (sel) return { value: sel.value, kind: 'choice' };

      var radio = field.querySelector('input[type="radio"]:checked');
      if (radio && !radio.disabled) return { value: radio.value, kind: 'choice' };
      if (field.querySelector('input[type="radio"]')) return { value: '', kind: 'choice' };

      /*
        All the text boxes, not the first. The custom lug/buckle pair is two inputs under one label,
        and reading only the first reported half a measurement as the whole answer. Joined with a
        slash — the same shape the preset options use ("24/22 mm") — and only the filled ones, so a
        half-completed pair shows what exists rather than a dangling separator. Every single-input
        field passes through unchanged: one value, no join.
      */
      var texts = field.querySelectorAll('input[type="text"]');
      if (texts.length) {
        var parts = [];
        texts.forEach(function (t) { if (t.value.trim()) parts.push(t.value.trim()); });
        return { value: parts.join(' / '), kind: 'text' };
      }

      return { value: '', kind: 'text' };
    }

    /* What to show when the control is empty, per kind of control. */
    function emptyLabel(kind, required) {
      if (kind === 'file') return 'No photo uploaded';
      if (kind === 'note') return 'No note';
      if (required) return 'Not selected';
      return 'None';
    }

    /*
      The panel lists the strap, not the form. Three kinds of row said nothing about what the
      customer is buying and only added distance between them and the button:

        1. No answer yet. Eight red "Not selected" rows on a fresh page are the form's job to
           chase, not the receipt's — the button is locked and names what is missing.
        2. A gate and its palette. "Stitch Colour: Custom colour" followed by "Choose Thread
           Colour: Cream" is one fact told twice. The gate keeps its name, the palette its
           answer: "Stitch Colour: Cream".
        3. "Match leather" / "Match underlay colour". The row above already gave that colour.
    */
    var NOI_LAI_CU = /^(match leather|match underlay colou?r|no)$/i;

    /*
      The keeper is two loops, so its answer is two facts, not one field. The gate's own wording
      says which: "two colours" means an upper and a lower, "one colour" means both loops share.
      Every other gate keeps its own label.
    */
    function tenGop(nhanCong, giaTriCong, thu) {
      if (/keeper/i.test(nhanCong)) {
        if (/two colou?rs/i.test(giaTriCong)) return thu === 0 ? 'Keeper Top' : 'Keeper Bottom';   /* 03/10: Top = vong xa khoa (Up loop), Bottom = vong gan khoa (Down loop) */
        if (/one colou?r/i.test(giaTriCong)) return 'Keepers (both)';
      }
      return nhanCong;
    }

    /* O nhap tay di kem mot cong so do: ten thuoc tinh bat dau bang "Custom ". */
    function laONhapTay(field) {
      if (!field || field.querySelector('.ccolor-grid, .cswatch-grid')) return false;
      if (!field.querySelector('input[type="text"]')) return false;
      return /^Custom\s/i.test(tenO(field));
    }

    function laBangMau(field) {
      return !!(field && field.querySelector('.ccolor-grid, .cswatch-grid'));
    }

    /* 10/10 (P4 lag): updateSummary la HAM VE khung tom tat (khong phai nguon property gio — submit tu dung gonProps(FormData(form))).
       Moi cu bam goi no 1-3 lan (change / buildThickness / syncCustomThickness / renderUpgrades...), moi lan dung FormData(form) ~35 ms (CPU 4x)
       va chen vao khung hinh dang ve -> INP 200-400 ms. Nay: gop N lan goi thanh 1, chay SAU khung hinh vua ve (rAF -> setTimeout 0; co timer
       150 ms du phong khi tab an, rAF khong chay). flushSummary() = chay bu NGAY neu dang cho — goi dau submit. */
    var _sumCho = false, _sumHen = 0;
    /* 11/10 LAG B3/E2 (sua sau QA #1): khung tom tat LUON cap nhat sau moi thay doi (khong con dieu kien "gan man hinh" — khach nhay toi nut mua
       thay duoc khung dung, khong day nut). Ve luc ranh: requestIdleCallback({timeout: 300}) (khong co -> setTimeout 150), gop N thay doi thanh 1 lan ve;
       flushSummary() ve bu NGAY truoc submit. Property gui gio KHONG doi (submit lay thang gonProps(FormData(form))). */
    var _sumCho = false, _sumHen = 0, _sumRic = false;
    function updateSummary() {
      if (_sumCho) return;
      _sumCho = true;
      if (window.requestIdleCallback) { _sumRic = true; _sumHen = window.requestIdleCallback(chayTomTat, { timeout: 300 }); }
      else { _sumRic = false; _sumHen = setTimeout(chayTomTat, 150); }
    }
    function chayTomTat() {
      if (!_sumCho) return;
      _sumCho = false;
      if (_sumRic && window.cancelIdleCallback) window.cancelIdleCallback(_sumHen); else clearTimeout(_sumHen);
      updateSummaryNow();
    }
    function flushSummary() { if (_sumCho) chayTomTat(); }
    /* 11/10 (QA #1): khach nhay toi nut mua (keo thanh cuon / End) trong luc ve tom tat dang cho -> ve bu NGAY trong su kien scroll (truoc khi trinh duyet
       ve khung hinh moi) — khong hien tom tat cu, khong day nut mua. Cung ap cho syncVariant tre (E4). */
    window.addEventListener('scroll', function () { if (_sumCho) chayTomTat(); if (typeof flushVariant === 'function') flushVariant(); }, { passive: true });
    function updateSummaryNow() {
      if (!sumList) return;
      if (GIO) { veTomTatGio(); return; }
      sumList.innerHTML = '';

      /* Read every field first: rule 2 has to see the one standing immediately after. */
      var truong = [];
      root.querySelectorAll('.cstrap__form .cfield').forEach(function (field) {
        if (field.closest('[hidden]')) return;
        var label = fieldLabel(field);
        if (!label) return;
        truong.push({ field: field, label: label, res: fieldValue(field) });
      });

      for (var i = 0; i < truong.length; i++) {
        var t = truong[i];
        var gt = t.res.value;

        /*
          Rule 2 — a gate and the palette(s) it opens collapse into the palette's answer. The
          keeper said the same thing three times: "Keeper Colour 2 loops: Custom - two colours",
          then "Up loop: Red", then "Down loop: Yellow". It now reads "Keeper Up: Red" /
          "Keeper Down: Yellow", and one colour across both loops reads "Double Keeper: Red".

          How many palettes to take is decided by what the gate ASKED for, never by "every
          palette that happens to follow": Underlay Colour sits directly beneath Choose Thread
          Colour, and a greedy sweep would let the stitch gate swallow it and rename it.
        */
        /*
          Cong MAU: "Custom colour" / "Custom - one colour" / "Custom - two colours". Phai
          ket thuc bang chu "colour(s)" — KHONG duoc chi bat dau bang "Custom". Lug Width va
          Length co lua chon "Custom size (enter below)", va mot regex chi doi dau chuoi da
          nuot ca hai: chung di tim bang mau, khong thay, roi bo luon hang. Khach nhap so do
          tay xong thi mat han dong Lug/Length khoi don.
        */
        if (/^(custom\b.*\b|one |two )colou?rs?$/i.test(gt)) {   /* 03/10: + ten keeper moi One colour / Two colours */
          var canLay = /two colou?rs/i.test(gt) ? 2 : 1;
          var bang = [];
          while (bang.length < canLay && truong[i + 1] && laBangMau(truong[i + 1].field)) {
            bang.push(truong[i + 1]);
            i++;
          }
          if (bang.length) {
            bang.forEach(function (b, k) {
              if (b.res.value) {
                themDong(tenGop(t.label, gt, k), b.res.value,
                         laHangLoi(t.field) || laHangLoi(b.field));
              }
            });
            continue;
          }
          /* Cong mo ma khong co bang mau nao theo sau: roi xuong duoi xu ly nhu o thuong,
             con hon la bo mat hang. */
        }

        /*
          Cong SO DO: "Custom size (enter below)" mo ra mot o nhap tay ngay duoi. Cau tra loi
          that nam o o nhap, khong nam o cong — nen hai cai gop thanh mot hang mang ten cong:
          "Lug Width: 23". Chua nhap gi thi chua co cau tra loi, bo hang.
        */
        if (/^custom\b/i.test(gt) && truong[i + 1] && laONhapTay(truong[i + 1].field)) {
          var o = truong[i + 1];
          i++;
          if (o.res.value) {
            themDong(t.label, o.res.value, laHangLoi(t.field) || laHangLoi(o.field));
          }
          continue;
        }

        if (!gt) continue;                 /* Rule 1 */
        if (NOI_LAI_CU.test(gt)) continue; /* Rule 3 */

        /* A 500-character note would blow the panel open. Show the head of it. */
        themDong(t.label, t.res.kind === 'note' && gt.length > 60 ? gt.slice(0, 60) + '…' : gt,
                 laHangLoi(t.field));
      }

      capNhatNut();
    }

    /* 07/10 (chu shop): khung khop gio — tung dong = mot property gui gio (cung ten, cung thu tu, cung gia tri).
       Bo: o "_", Note, Wrist Size, Needs review, anh dong ho. Dong co phu phi -> "+$x" ben phai (phiTheoDong). */
    function veTomTatGio() {
      sumList.innerHTML = '';
      var fd = null;
      if (gomProps) {
        try { fd = gomProps(); } catch (e) { console.warn('cstrap: tom tat gio', e); }
      }
      if (fd) {
        var phi = phiTheoDong(fd);
        fd.forEach(function (v, k) {
          var m = /^properties\[(.*)\]$/.exec(k);
          if (!m || typeof v !== 'string' || !v.trim()) return;
          var t = m[1];
          if (t.charAt(0) === '_' || /^(Note|Needs review)$/.test(t) || /^Watch Photo/.test(t)) return;   /* 08/10 15:26: tom tat hien Wrist Size (C3) */
          themDong(t, v, false, phi[t]);
        });
      }
      capNhatNut();
    }
    /* Phu phi -> dong gay ra no. Nguon = dung danh sach dang cong vao gia (ladderExtras / upgradeItems). */
    function phiTheoDong(fd) {
      var r = {};
      var ds = LADDER ? ladderExtras().filter(function (m) { return m.cents > 0; }) : upgradeItems();
      ds.forEach(function (m) {
        var t = m.ten || '', d;
        if (/curved/i.test(t)) d = 'End Shape';
        else if (/lining/i.test(t)) d = 'Lining';
        else if (/stitch/i.test(t)) d = 'Stitching';
        else if (/keeper/i.test(t)) d = 'Keeper';
        else d = fd.get('properties[Buckle Type]') ? 'Buckle Type' : 'Buckle';
        r[d] = '+' + m.tien;
      });
      return r;
    }

    function themDong(ten, giaTri, laLoi, phi) {
      var item = document.createElement('div');
      item.className = 'csum__item' + (laLoi ? ' csum__item--loi' : '');

      var k = document.createElement('span');
      k.className = 'csum__k';
      k.textContent = ten;

      var v = document.createElement('span');
      v.className = 'csum__v';
      v.textContent = giaTri;

      item.appendChild(k);
      item.appendChild(v);
      if (phi) {
        var p = document.createElement('span');
        p.className = 'csum__p';
        p.textContent = phi;
        item.appendChild(p);
      }
      sumList.appendChild(item);
    }

    root.addEventListener('input', function (e) {
      if (e.target.type === 'text' || e.target.tagName === 'TEXTAREA') updateSummary();
    });

    /*
      The upgrade's variant and price come from the product itself, so there is no number typed into
      the JavaScript that can drift away from what the customer is actually charged. When the product
      is missing or sold out both are zero, `curvedWanted()` can never be true, and the whole feature
      goes quiet instead of promising a charge the cart cannot take.
    */
    /*
      Every variant, with the money already formatted by Liquid. Formatting it here rather than in
      JavaScript is deliberate: the shop's money format is a template string, and rebuilding it in
      script means guessing at currencies, separators and decimal places that Liquid already knows.
    */
    var OPTION_NAMES = CFG.optionNames;
    var VARIANTS = CFG.variants;

    var curvedSel = document.getElementById('cf-' + SID + '-curved-end') || radioNhuSelect('Curved End', 'data-curved-end');   /* 21/09: tile radio */
    function curvedWanted() {
      return !!curvedSel && curvedSel.value.indexOf('Yes') === 0;
    }
    /* 01/10 (chu shop): dang dau day TRONG ANH (CFG.anhCong <- builder2d.curved_end). Anh cong -> chon san Curved va
       KHONG tinh +$15 cho lua chon do; +$15 CHI khi khach doi Straight -> Curved tren day anh thang. Doi Curved -> Straight
       tren day anh cong: giu gia (khong tru). Moi cho tinh tien (thang gia, bien the, dong phu thu) doc curvedCharged(). */
    var ANH_CONG = false;   /* 08/10 21:55 (chu shop): bo luat "as pictured" — Curved chi khi khach chon, luon tinh phi */
    function curvedCharged() { return curvedWanted() && !ANH_CONG; }
    /* End Shape gui xuong: giu dung dang anh -> "<X> (as pictured)"; khach doi -> "Curved" / "Straight". */
    function endShapeGui() {
      var chon = curvedWanted() ? 'Curved' : 'Straight', anh = ANH_CONG ? 'Curved' : 'Straight';
      return chon;   /* 21:55: "Straight" / "Curved" — khong con "(as pictured)" */
    }
    if (ANH_CONG && curvedSel) {
      try {
        var oYes = null;
        (curvedSel.options ? Array.prototype.slice.call(curvedSel.options) : []).forEach(function (o) { if (!oYes && String(o.value).indexOf('Yes') === 0) oYes = o; });
        if (oYes) {
          curvedSel.value = oYes.value;
          /* Dropdown (V1): chu "Yes (+$15)" se noi doi gia -> doi CHU hien, value giu de curvedWanted() khong doi.
             01/10 (chu shop): anh cong -> chi "Yes" (dua len dau, mac dinh) | "No"; anh thang giu "No" | "Yes (+$15)". */
          if (curvedSel.tagName === 'SELECT' && oYes.nodeType === 1) {
            oYes.textContent = 'Yes';
            if (oYes !== curvedSel.options[0]) curvedSel.insertBefore(oYes, curvedSel.options[0]);
            curvedSel.value = oYes.value;
          }
        }
      } catch (e) { console.warn('cstrap: ANH_CONG chon san', e); }
    }

    /*
      The buckle tiles are pictures of finishes, but only the mechanism is priced, so each tile
      carries the Buckle Type it belongs to and seven tiles collapse onto two variants. Without a
      checked tile — the field is switched off for this template — the order takes Standard.
    */
    function buckleTypeWanted() {
      var picked = root.querySelector('input[name="properties[Buckle Finish]"]:checked');
      return (picked && picked.getAttribute('data-buckle-type')) || 'Standard';
    }

    /*
      Leather is priced by name: the Kind of Leather answer IS the option value, so a product that
      carries the Leather option charges per hide, and one that does not simply ignores the key.
      The double stitch rides the Buckle Type axis — Shopify allows three options and all three are
      spoken for, so each buckle value exists twice, plain and "· Double", and the stitch answer
      picks between them.
    */
    function leatherWanted() {
      var el = document.getElementById('cf-' + SID + '-kind-of-leather');
      return (el && el.value) || '';
    }
    function doubleWanted() {
      var r = root.querySelector('input[name="properties[Style of Stitches]"]:checked');
      return !!r && (r.value === 'Classic Double Stitches' || r.value === 'Double Stitches' || r.value === 'Box X Stitches');   /* 25/10 sep: Box X (PAM) cung +$5 nhu Double */   /* 23/10: 'Double Stitches' = chi doi trang PAM, cung +phi */
    }
    function stitchFeeName() {
      var r = root.querySelector('input[name="properties[Style of Stitches]"]:checked');
      return r && r.value === 'Box X Stitches' ? 'Box X stitches' : 'Double stitches';
    }
    function wantedOptions() {
      var bt = buckleTypeWanted() + (doubleWanted() ? ' · Double' : '');
      return { 'End Shape': curvedCharged() ? 'Curved' : 'Straight', 'Buckle Type': bt, 'Leather': leatherWanted() };
    }

    /*
      THANG GIA (chu shop chot 14/09/2026). Bai chi con mot option `Price`, moi tong tien mot bien the.
      Phu phi la bang CFG.ladder.rules (cents) do Liquid doc tu shop.metafields.custom.price_rules —
      cung bang script sinh thang, nen tong cong ra luon co trong VARIANTS. Khong co thi la loi cau
      hinh: khoa nut, bao loi, KHONG chon gan nhat, KHONG gui bien the re nhat.
      Tien van do Liquid dinh dang: CFG.ladder.money[cents], CFG.ladder.badge[cents], v.money.
    */
    var LADDER = CFG.ladder || null;
    var liningSel = document.getElementById('cf-' + SID + '-lining-leather');
    function liningWanted() {
      return (liningSel && liningSel.value) || '';
    }
    function ladderMoney(cents) {
      return (LADDER && LADDER.money && LADDER.money[String(cents)]) || '';
    }
    function ladderBase() {
      var lb = LADDER.rules && LADDER.rules.leatherBase;
      var da = leatherWanted();
      if (lb && da && lb[da] !== undefined) return lb[da];
      return LADDER.base;
    }
    /* Tung khoan khach them len day: [{ten hien thi, cents, tien}] — chi nhung khoan co trong rules. */
    function ladderExtras() {
      var r = LADDER.rules || {};
      var ra = [];
      function them(nhom, khoa, ten) {
        var c = (r[nhom] && r[nhom][khoa]) || 0;
        ra.push({ nhom: nhom, khoa: khoa, ten: ten, cents: c, tien: ladderMoney(c) });
      }
      var bt = buckleTypeWanted();
      them('buckle', bt, /pre-?v/i.test(bt) ? bt + ' buckle' : bt);
      them('end', curvedCharged() ? 'Curved' : 'Straight', 'Curved end');
      var lot = liningWanted();
      if (lot) them('lining', lot, lot + ' lining');
      them('stitch', doubleWanted() ? 'Double' : 'Single', stitchFeeName());
      /* 03/10 (chu shop): Keeper "Two colours" +$5 — bang price_rules.keeper {One: 0, Two: 500}. Chua co nhom keeper -> 0. */
      var kg = root.querySelector('select[id$="-keeper-colour"]');
      if (kg && /^two colou?rs$/i.test(kg.value) && !kg.closest('[hidden]')) them('keeper', 'Two', 'Two-colour keeper');
      return ra;
    }
    function ladderTotal() {
      return ladderExtras().reduce(function (t, m) { return t + m.cents; }, ladderBase());
    }
    function ladderVariant(cents) {
      for (var i = 0; i < VARIANTS.length; i++) {
        if (VARIANTS[i].cents === cents && VARIANTS[i].available) return VARIANTS[i];
      }
      return null;
    }

    /* The variant whose options match every paid field the page knows about. Options the product
       does not have are simply absent from OPTION_NAMES and drop out of the comparison. */
    function pickVariant() {
      if (LADDER) return ladderVariant(ladderTotal());
      var want = wantedOptions();
      for (var i = 0; i < VARIANTS.length; i++) {
        var ok = true;
        for (var j = 0; j < OPTION_NAMES.length; j++) {
          var name = OPTION_NAMES[j];
          if (want[name] && VARIANTS[i].options[j] !== want[name]) { ok = false; break; }
        }
        if (ok) return VARIANTS[i];
      }
      return null;
    }

    /*
      The field drives the hidden variant id, so the cart is charged by the same control the customer
      answered. The property is dropped in this mode rather than sent alongside: the variant already
      says Curved on the order, and a line that reports the end shape twice invites the two to
      disagree the first time either wording changes. Where there is no variant to pick, the property
      is all the workshop has, so it stays.
    */
    var idInput = document.querySelector('#cstrap-form-' + SID + ' input[name="id"]');
    var PRICED = CFG.priced;

    var baseEl = root.querySelector('[data-base]');
    var upsEl = root.querySelector('[data-ups]');
    var totalEl = root.querySelector('[data-total]');
    var ZERO_MONEY = CFG.zeroMoney;

    /*
      The hide is not an upgrade — it is the strap. Charging Ostrich as "$75 base + $34 premium"
      described a $75 strap the customer was not buying and then billed them for the difference;
      an Ostrich strap costs $109 and the base line now says so. What is left under Premium
      upgrades is only what the customer added ON TOP of that strap — a curved end, a different
      buckle, a double stitch — and each is named with its own price instead of arriving as one
      unexplained sum.

      Every figure comes from a variant Liquid already priced and formatted, so nothing is
      calculated here and no money is formatted in script. base + each item = total exactly,
      because the option axes price additively.
    */
    function baseVariant() {
      if (LADDER) return ladderVariant(ladderBase());
      var want = { 'End Shape': 'Straight', 'Buckle Type': 'Standard', 'Leather': leatherWanted() };
      for (var i = 0; i < VARIANTS.length; i++) {
        var ok = true;
        for (var j = 0; j < OPTION_NAMES.length; j++) {
          var name = OPTION_NAMES[j];
          if (want[name] && VARIANTS[i].options[j] !== want[name]) { ok = false; break; }
        }
        if (ok) return VARIANTS[i];
      }
      return null;
    }

    /* What the customer added on top of the strap itself. Only paid, only chosen. */
    function upgradeItems() {
      if (LADDER) {
        return ladderExtras().filter(function (m) { return m.cents > 0; })
          .map(function (m) { return { ten: m.ten, tien: m.tien }; });
      }
      var ex = CFG.extras || {};
      var ra = [];
      if (curvedCharged() && ex.curved && ex.curved.cents > 0) {
        ra.push({ ten: 'Curved end', tien: ex.curved.money });
      }
      var bt = buckleTypeWanted();
      if (/butterfly|deployant/i.test(bt) && ex.butterfly && ex.butterfly.cents > 0) {
        ra.push({ ten: bt, tien: ex.butterfly.money });
      } else if (/pre-?v/i.test(bt) && ex.prev && ex.prev.cents > 0) {
        ra.push({ ten: bt + ' buckle', tien: ex.prev.money });
      }
      if (doubleWanted() && ex.double && ex.double.cents > 0) {
        ra.push({ ten: stitchFeeName(), tien: ex.double.money });
      }
      return ra;
    }

    function veDong(lop, ten, tien) {
      var d = document.createElement('div');
      d.className = lop;
      var a = document.createElement('span');
      a.textContent = ten;
      var b = document.createElement('span');
      b.textContent = tien;
      d.appendChild(a);
      d.appendChild(b);
      return d;
    }

    /* 12/10 (chu shop): ten dong trong BANG GIA gan nut Add to cart — ngan, giong ten dong phu phi cua gio ADDON. CHI de HIEN THI:
       m.ten giu nguyen cho _Pricing / phiTheoDong (khong doi property gui gio, khong doi gia). */
    function tenDong(t) {
      t = String(t || '');
      if (/pre-?v/i.test(t)) return 'Pre-V buckle';
      if (/butterfly/i.test(t)) return 'Butterfly clasp';
      if (/deployant/i.test(t)) return 'Deployant clasp';
      if (/curved/i.test(t)) return 'Curved end';
      if (/lining/i.test(t)) return 'Lining upgrade';
      if (/stitch/i.test(t)) return /box x/i.test(t) ? 'Box X stitch' : 'Double stitch';
      if (/keeper/i.test(t)) return 'Two-colour keeper';
      return t;
    }

    function renderUpgrades() {
      if (!upsEl) return;
      if (GIO) {   /* 07/10: phu phi da nam tren tung dong; khung chi con dong Total */
        upsEl.hidden = true;
        var hn = baseEl && baseEl.closest('.csum__row');
        /* 11/10 toi (sep, hoc code cu 25/8): cuoi khung = Strap base price -> Options +$x -> Total (tinh tu bang phu phi, dung ca khi tong chua co bien the) */
        if (LADDER && baseEl) {
          var bc = ladderBase(), tc = ladderTotal();
          var fm = function (c) { return '$' + (c / 100).toFixed(2); };
          baseEl.textContent = fm(bc);
          if (hn) hn.style.display = '';
          upsEl.innerHTML = '';
          /* 12/10 (chu shop): moi phu phi dang chon = 1 dong (ten ngan + gia), khong con dong gop "Options" */
          var phanGio = ladderExtras().filter(function (m) { return m.cents > 0; });
          if (phanGio.length) {
            upsEl.hidden = false;
            phanGio.forEach(function (m) { upsEl.appendChild(veDong('csum__row csum__row--upitem', tenDong(m.ten), '+' + (m.tien || fm(m.cents)))); });
          }
          if (totalEl) totalEl.textContent = fm(tc);
        } else if (hn) hn.style.display = 'none';
        if (typeof updateSummary === 'function') updateSummary();
        return;
      }
      upsEl.innerHTML = '';
      var muc = upgradeItems();
      /* Nothing added: no heading, no "+$0.00" row answering a question nobody asked. */
      if (!muc.length) { upsEl.hidden = true; return; }
      upsEl.hidden = false;
      upsEl.appendChild(veDong('csum__row csum__row--up', 'Premium upgrades', ''));
      muc.forEach(function (m) {
        upsEl.appendChild(veDong('csum__row csum__row--upitem', tenDong(m.ten), '+' + m.tien));
      });
    }

    /*
      Tong khong co trong thang = loi cau hinh (rules doi ma thang chua sinh lai). Khoa nut them gio,
      bao trong #cerr-, ghi console de nguoi sua doc duoc; nut mo lai ngay khi tong quay ve thang.
      Nut va hop loi tra cuu lai moi lan vi `form`/`errBox` duoc gan sau doan nay (var hoisting).
    */
    function khoaNutGia(total) {
      var btn = document.querySelector('#cstrap-form-' + SID + ' [type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.dataset.ladderLocked = '1'; }
      var q = root.querySelector('[data-ladder-quote]');
      if (!q && btn && btn.parentNode) {
        /* 02/10 (chu shop): khong dung khung loi — mot dong ngay duoi nut, khach biet phai lam gi (khong chan im lang) */
        q = document.createElement('p');
        q.setAttribute('data-ladder-quote', '1');
        q.className = 'cquote';
        q.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.45;color:#b3391f;';
        q.innerHTML = 'This combination needs a custom quote. Email <a href="mailto:support@xilugs.com" style="color:inherit;text-decoration:underline">support@xilugs.com</a> and we\'ll confirm the price.';
        btn.parentNode.insertBefore(q, btn.nextSibling);
      }
      if (q) q.hidden = false;
      console.error('cstrap ladder: total ' + total + ' not in ladder', VARIANTS.map(function (v) { return v.cents; }));
    }
    function moNutGia() {
      var btn = document.querySelector('#cstrap-form-' + SID + ' [type="submit"]');
      if (btn && btn.dataset.ladderLocked) { btn.disabled = false; btn.removeAttribute('aria-disabled'); delete btn.dataset.ladderLocked; }
      var q = root.querySelector('[data-ladder-quote]');
      if (q) q.hidden = true;
    }
    /* Ba o an cho xuong/ke toan: khoa, dau day, phep cong — chi co tren bai thang gia. */
    function ghiThuocTinhThang(b, v) {
      var oKhoa = root.querySelector('[data-ladder-buckle]');
      var oDau = root.querySelector('[data-ladder-end]');
      var oTien = root.querySelector('[data-ladder-pricing]');
      if (oKhoa) oKhoa.value = buckleTypeWanted();
      if (oDau) oDau.value = endShapeGui();
      if (oTien) {
        var phan = ladderExtras().filter(function (m) { return m.cents > 0; })
          .map(function (m) { return m.ten + ' ' + m.tien; });
        oTien.value = b.money + ' base' + (phan.length ? ' + ' + phan.join(' + ') : '') + ' = ' + v.money;
      }
    }


    /* 08/10 21:55 (chu shop): gia DUOI TEN = gia goc bien the (Straight + Classic), khop feed Google / Meta — khong nhay theo lua chon.
       TONG da cong lua chon nam trong .cstrap__tong (an); nut Add to cart, thanh sticky, nut Review doc o day (su kien cstrap:tong). */
    function oTong() {
      var t = root.querySelector('.cstrap__tong');
      if (!t) { t = document.createElement('span'); t.className = 'cstrap__tong'; t.hidden = true; root.appendChild(t); }
      return t;
    }
    /* 11/10 LAG B3/E4: syncVariant (tinh gia + id bien the + renderUpgrades) sau cu bam chay SAU khung hinh vua ve (rAF -> setTimeout 0, du phong 150 ms),
       gop nhieu su kien thanh 1. Luc submit van goi syncVariant() truc tiep (khong doi) + flushVariant() dau handler. */
    var _svCho = false;
    function syncVariantLazy() {
      if (_svCho) return;
      _svCho = true;
      var chay = function () { if (!_svCho) return; _svCho = false; syncVariant(); };
      if (window.requestAnimationFrame) window.requestAnimationFrame(function () { setTimeout(chay, 0); });
      setTimeout(chay, 150);
    }
    function flushVariant() { if (_svCho) { _svCho = false; syncVariant(); } }
    function syncVariant() {
      var v = pickVariant();
      if (!v) {
        /* 11/10 toi (sep): con muc CHUA CHON -> KHONG khoa nut (bam = cuon toi muc thieu nhu thuong); chon du ma tong khong co trong thang moi khoa + dong bao gia */
        if (LADDER) { if (findMissing().length) moNutGia(); else khoaNutGia(ladderTotal()); }
        renderUpgrades();
        return;
      }
      if (LADDER) moNutGia();
      if (idInput) idInput.value = v.id;
      /* 12/10: dong tra gop Shop Pay (form.installment) tinh theo TONG dang chon, khong theo gia goc */
      document.querySelectorAll('form.installment input[name="id"]').forEach(function (x) { if (x.value !== String(v.id)) { x.value = v.id; x.dispatchEvent(new Event('change', { bubbles: true })); } });
      var b = baseVariant() || v;
      if (baseEl) baseEl.textContent = b.money;
      if (totalEl) totalEl.textContent = v.money;
      renderUpgrades();
      /* 12/10 (chu shop): gia DUOI TEN = gia goc luc tai trang (khop feed Google), KHONG doi theo lua chon, KHONG con dong ghi chu.
         Gia theo lua chon doc o bang "Base price / phu phi / Total" gan nut Add to cart (renderUpgrades) + .cstrap__tong. */
      var tongEl = oTong();
      if (tongEl.textContent !== v.money) { tongEl.textContent = v.money; root.dispatchEvent(new CustomEvent('cstrap:tong', { bubbles: true })); }
      if (LADDER) ghiThuocTinhThang(b, v);
    }

    if (PRICED) {
      /*
        Thang gia (chu shop 14/09 toi): BO property Curved End — o an End Shape da ghi Straight/Curved
        cho xuong, con gia tri "Yes (+$15)" cua select se lo chuoi gia ra checkout/email. Nhanh cu
        (bien the End Shape x Buckle Type) giu nguyen nhu Buoc 2.
      */
      if (LADDER && curvedSel) curvedSel.removeAttribute('name');
      root.addEventListener('change', function (e) {
        if (e.target === curvedSel || (curvedSel && curvedSel.contains && curvedSel.contains(e.target)) || e.target.hasAttribute('data-buckle-type') ||
            e.target.id === 'cf-' + SID + '-kind-of-leather' ||
            e.target === liningSel ||
            e.target.name === 'properties[Style of Stitches]' ||
            /-keeper-colour$/.test(e.target.id || '')) syncVariantLazy();   /* 03/10: keeper Two colours +$5 -> tinh lai gia */
      });
      syncVariant();
    }

    /*
      Lot da (thang gia): dropdown Lining Leather -> luoi mau cua dung da do. Zermatt lay mau rieng
      (LINING.own), Epsom/Togo muon nguyen catalog da (anh swatch, hex, co het hang). Chu "(+$5)" ben
      ten da la chuoi Liquid da dinh dang (CFG.ladder.badge); value van la ten tran cho property.
    */
    var liningBox = document.getElementById('cstrap-color-lining-' + SID + '');
    function buildLining() {
      if (!liningSel || !liningBox) return;
      var kind = liningSel.value;
      buildColourGrid(kind, liningBox, 'properties[Lining Colour]',
        kind + ' Lining Colour <span class="req">*</span><span class="cfield__colon">:</span>', true);
      syncFieldHint(liningBox);
      if (typeof updateSummary === 'function') updateSummary();
    }
    if (liningSel && liningBox && LINING) {
      var hien = LINING.leathers || [];
      var rLot = (LADDER && LADDER.rules && LADDER.rules.lining) || {};
      Array.prototype.slice.call(liningSel.options).forEach(function (opt) {
        if (hien.indexOf(opt.value) === -1) { opt.remove(); return; }
        var nhan = (LADDER && LADDER.badge && LADDER.badge[String(rLot[opt.value] || 0)]) || '';
        opt.textContent = nhan ? opt.value + ' (' + nhan + ')' : opt.value;
      });
      liningSel.addEventListener('change', buildLining);
      buildLining();
    }

    function updateUpgrades() {
      if (PRICED) { syncVariantLazy(); return; }
      if (upsEl) { upsEl.innerHTML = ''; upsEl.hidden = true; }
    }

    if (curvedSel) curvedSel.addEventListener('change', updateUpgrades);
    if (PRICED) syncVariant(); else updateUpgrades();   /* lan dau luc khoi tao: dong bo nhu cu (khong tre) */

    /* Validate required options ourselves so we can list them all at once */
    var form = document.getElementById('cstrap-form-' + SID + '');
    var errBox = document.getElementById('cerr-' + SID + '');
    var errList = errBox ? errBox.querySelector('.cerr__list') : null;

    /* 03/10 (chu shop, loi don XILUGS-1066: "Length: Custom size (enter below)" ma khong co so do): o chon dang la
       Custom / Request ma hop nhap tay ben duoi van AN + KHOA (trinh duyet khoi phuc gia tri o khi Back / tai lai,
       hoac JS khac dat gia tri ma khong ban 'change') -> o nhap bi bo qua luc kiem va luc gui. Truoc khi kiem: dong
       bo lai moi cap o chon -> hop, de o nhap mo ra va bi bat buoc nhu binh thuong. */
    var CAP_CUSTOM = [
      ['cf-' + SID + '-lug-width', 'ccustom-lug-' + SID, /^custom/i],
      ['cf-' + SID + '-length', 'ccustom-len-' + SID, /^custom/i],
      ['cf-' + SID + '-thickness', 'ccustom-thk-' + SID, /^request/i],
      ['cf-' + SID + '-stitch-style', 'cstitchstyle-custom-' + SID, /^custom/i],
      ['cf-' + SID + '-stitch-colour', 'cstitch-custom-' + SID, /^custom/i],
      ['cf-' + SID + '-edge-colour', 'cedge-custom-' + SID, /^custom/i],
      ['cf-' + SID + '-underlay-colour', 'cunderlay-custom-' + SID, /^custom/i]
    ];
    function dongBoCustom() {
      CAP_CUSTOM.forEach(function (c) {
        var sel = document.getElementById(c[0]), box = document.getElementById(c[1]);
        if (sel && sel.disabled && ((window.CSTRAP_PAM && window.CSTRAP_PAM.active(root)) || (window.CSTRAP_APW && window.CSTRAP_APW.active(root)))) return;
        if (sel && box && c[2].test(sel.value || '') && box.hidden) sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    window.addEventListener('pageshow', dongBoCustom);
    var LOI_CUSTOM = {
      'properties[Custom Length]': 'Enter your custom length',
      'properties[Custom Length Long]': 'Enter the long end in mm',
      'properties[Custom Length Short]': 'Enter the short end in mm',
      'properties[Custom Lug Width]': 'Enter your custom lug width',
      'properties[Custom Buckle Width]': 'Enter your buckle width',
      'properties[Custom Thickness]': 'Enter your custom thickness'
    };

    function findMissing() {
      var missing = [];
      dongBoCustom();
      root.querySelectorAll('.cstrap__form .cfield').forEach(function (field) {
        if (field.closest('[hidden]')) return;

        var select = field.querySelector('select[required]');
        if (select && !select.value) {
          missing.push({ field: field, focus: select, label: fieldLabel(field) });
          return;
        }

        var radio = field.querySelector('input[type="radio"][required]');
        if (radio && !radio.disabled && !field.querySelector('input[type="radio"]:checked')) {
          missing.push({ field: field, focus: radio, label: fieldLabel(field) });
          return;
        }

        /* 03/10: kiem TUNG o nhap bat buoc (Custom Lug Width + Custom Buckle Width chung mot o — truoc chi kiem o dau) */
        var text = [].slice.call(field.querySelectorAll('input[type="text"][required]')).filter(function (x) { return !x.disabled && !x.value.trim(); })[0];
        if (text) {
          missing.push({ field: field, focus: text, label: fieldLabel(field), msg: LOI_CUSTOM[text.name] });
        }
      });
      if (window.CSTRAP_PAM) window.CSTRAP_PAM.validate(root, missing);
      if (window.CSTRAP_SIZE) CSTRAP_SIZE.kiem(SID, missing);   /* 08/10: o size tu go — luat + cau bao chung V1 + V2 (assets/cstrap-size.js) */
      return missing;
    }

    /* One message element per field, created once and reused. Placed last inside the field so it
       sits under the control and its hint rather than between the label and the input. */
    function errLine(field) {
      var el = field.querySelector('.cfield__err');
      if (!el) {
        el = document.createElement('p');
        el.className = 'cfield__err';
        field.appendChild(el);
      }
      return el;
    }

    function clearErrors() {
      if (errBox) errBox.hidden = true;
      root.querySelectorAll('.cfield.has-error').forEach(function (f) { f.classList.remove('has-error'); });
      root.querySelectorAll('[aria-invalid="true"]').forEach(function (c) {
        c.removeAttribute('aria-invalid');
        c.removeAttribute('aria-describedby');
      });
    }

    /*
      `scroll` is true only when the customer pressed Add to cart, so the error box is brought into
      view once. It is false when this runs from the live `change` handler below — otherwise every
      option the customer picks to FIX an error would smooth-scroll the page back to the error box,
      yanking them away from the field they just touched. They asked for it to stay put; a partial
      list that keeps updating in place is the fix, a jumping viewport is the bug.
    */
    /* 02/10 (chu shop): khong hien khung .cerr — cuon toi o thieu dau tien (mo hop Customise neu o nam trong do), focus. */
    function diToiThieu(m) {
      if (!m || !m.field) return;
      var MTO = root.cstrapMto;
      if (MTO && MTO.chua && MTO.chua(m.field)) {
        MTO.mo();
        setTimeout(function () { try { MTO.toi(m.field); } catch (x) { console.warn('cstrap: diToiThieu', x); } }, 300);
      } else {
        /* 11/10: < 1100 muc thieu nam NGAY DUOI day khung preview dang dinh (--cspv-dinh, do luc chay) + 12px; PC giu 120px */
        var dinh = parseFloat(document.documentElement.style.getPropertyValue('--cspv-dinh'));
        var le = window.matchMedia && window.matchMedia('(max-width: 749px)').matches && dinh >= 0 ? dinh + 12 : 120;
        var y = m.field.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - le;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
      if (m.focus && (m.focus.tagName === 'SELECT' || m.focus.type === 'text')) {
        setTimeout(function () { try { m.focus.focus({ preventScroll: true }); } catch (x) { m.focus.focus(); } }, 350);
      }
    }

    function showErrors(missing, scroll) {
      if (!errBox || !errList) return;
      errList.innerHTML = '';
      root.querySelectorAll('.cfield.has-error').forEach(function (f) { f.classList.remove('has-error'); });
      root.querySelectorAll('[aria-invalid="true"]').forEach(function (c) {
        c.removeAttribute('aria-invalid');
        c.removeAttribute('aria-describedby');
      });

      missing.forEach(function (m) {
        m.field.classList.add('has-error');
        var line = errLine(m.field);
        line.textContent = m.msg ? m.msg + '.' : 'Please select ' + m.label + '.';
        /*
          A red border is invisible to a screen reader and to anyone who cannot separate red from
          grey — roughly one man in twelve. `aria-invalid` announces the state and
          `aria-describedby` reads the sentence out with the field, so the message is not carried
          by colour alone.
        */
        if (!line.id) line.id = 'cerrline-' + SID + '-' + Math.random().toString(36).slice(2, 8);
        if (m.focus && m.focus.setAttribute) {
          m.focus.setAttribute('aria-invalid', 'true');
          m.focus.setAttribute('aria-describedby', line.id);
        }

        var li = document.createElement('li');
        var link = document.createElement('button');
        link.type = 'button';
        link.textContent = m.label + ' — choose this option';
        link.addEventListener('click', function () {
          m.field.scrollIntoView({ block: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'start' : 'center', behavior: 'smooth' });
          if (m.focus.tagName === 'SELECT' || m.focus.type === 'text') m.focus.focus();
        });
        li.appendChild(link);
        errList.appendChild(li);
      });

      errBox.hidden = true;
      if (scroll) diToiThieu(missing[0]);
    }

    /* Ready-to-ship window: today + the lead time the merchant set, in whole days. */
    var shipEl = root.querySelector('.cship');
    if (shipEl) {
      var minDays = parseInt(shipEl.dataset.leadMin, 10) || 3;
      var maxDays = parseInt(shipEl.dataset.leadMax, 10) || 5;
      var fmt = { month: 'short', day: 'numeric', year: 'numeric' };
      var from = new Date();
      from.setDate(from.getDate() + minDays);
      var to = new Date();
      to.setDate(to.getDate() + maxDays);
      shipEl.querySelector('.cship__text').textContent =
        'Estimated ready to ship: ' +
        from.toLocaleDateString('en-US', fmt) + ' – ' + to.toLocaleDateString('en-US', fmt);
    }

    var confirmBox = document.getElementById('cconfirm-' + SID + '');
    var confirmInput = document.getElementById('cconfirm-input-' + SID + '');

    if (form) {
      /* 16/09/2026 — LOP CHAN THU HAI. Mot <button> khong co type nam trong form la nut SUBMIT
         theo chuan HTML. Widget ben thu ba (Judge.me, app danh gia...) dung nut khong type rat
         nhieu; neu cai nao roi vao trong form thi mot cu bam la them hang vao gio. The </form>
         (sua cung ngay) chan duong chinh; cai nay chan duong con: bat click o pha BAT va ep
         type="button" cho moi nut la. Nut them gio co type="submit" san nen khong bi dung toi. */
      form.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('button') : null;
        if (!t || t.getAttribute('type')) return;
        t.setAttribute('type', 'button');
      }, true);
    /* 03/10 (chu shop): THU TU property gui vao don = thu tu cac muc tren trang (admin hien theo thu tu gui):
       _Pricing dau; moi lua chon chinh lien voi o Custom / phu cua no; Engraving, Note, Wrist Size cuoi.
       KHONG gui o rong (Engraving, Note, Custom... trong). KHONG doi ten / gia tri property nao.
       O khong co trong danh sach -> giu thu tu gap, dat truoc Engraving / Note / Wrist Size. */
    /* 03/10 (chu shop): Keeper trong DON MOI = "Keeper Top" (vong xa khoa — Up loop) + "Keeper Bottom" (vong gan khoa —
       Down loop). One colour -> Top = Bottom = cung mau. Match leather / Match underlay / As pictured -> giu "Keeper Colour".
       Bo key cu Custom Keeper Colour / Custom Keeper 2 Colour (gio hang van doc ca key cu cho don cu). O de trong = theo da. */
    function doiKeeper(fd, form) {
      var kg = form && form.querySelector('select[id$="-keeper-colour"]');
      var mot = fd.get('properties[Custom Keeper Colour]'), hai = fd.get('properties[Custom Keeper 2 Colour]');
      fd.delete('properties[Custom Keeper Colour]'); fd.delete('properties[Custom Keeper 2 Colour]');
      if (!kg || kg.closest('[hidden]')) return fd;
      var v = kg.value || '';
      mot = (mot || '').trim(); hai = (hai || '').trim();
      if (/^one colou?r$/i.test(v)) {
        if (mot) { fd.set('properties[Keeper Top]', mot); fd.set('properties[Keeper Bottom]', mot); }
        else fd.set('properties[Keeper Colour]', 'Match leather');
      } else if (/^two colou?rs$/i.test(v)) {
        fd.set('properties[Keeper Top]', mot || 'Match leather');
        fd.set('properties[Keeper Bottom]', hai || 'Match leather');
      }
      return fd;
    }
    /* 07/10 (chu shop, ban tong hop 21:03): DUNG LAI bo property gui vao gio/don — gon, dung thu tu co dinh.
       Chi doi LUC GUI: cac o trong form giu nguyen (preview 2D, gia, khung tom tat van doc chung). Moi duong them gio
       (nut chinh, thanh .cbar, nut trong hop Customise / review) deu submit form nay nen deu qua day.
       Thu tu: Style · Leather · Lug Width · Length · Form · End Shape · Tip Shape · Stitching · Edge · Underlay · Keeper ·
       Lining · Buckle (· Buckle Type) · Spring bar · [o khac] · Watch Photo · Engraving · Note. _Pricing giu nguyen, dung dau.
       - Leather = Kind of Leather - Colour; Skin of Leather khong gui.
       - Lug Width luon co "mm"; khach tu go -> "Lug Width (Custom): <lug>/<buckle> mm". Length tu go -> "Length (Custom): <long>/<short> mm".
       - Form = Strap form - do day (o Custom Thickness neu khach tu go). End Shape chi Straight / Curved.
       - Stitching = kieu - mau chi; Edge / Underlay = mau (o Custom ... neu co). Keeper hai mau -> "<sat khoa> (fixed) / <xa khoa> (floating)"
         (Keeper Bottom = vong 2 = sat khoa tren preview 2D; Keeper Top = vong 1 = vong truot).
       - Lining = da lot (chu dau: Zermatt / Epsom / Togo) - mau. Buckle = Buckle Finish ("Classic Silver"). Buckle Type = Standard -> khong gui. */
    function gonProps(fd, form) {
      var pr = {}, thuTu = [], da = {}, ra = new FormData(), ra2 = [];
      fd.forEach(function (v, k) {
        var m = /^properties\[(.*)\]$/.exec(k);
        if (!m) { ra2.push([k, v]); return; }
        if (!pr[m[1]]) { pr[m[1]] = []; thuTu.push(m[1]); }
        pr[m[1]].push(v);
      });
      function lay(t) { da[t] = 1; var v = pr[t] && pr[t][0]; return typeof v === 'string' ? v.trim() : ''; }
      function chon(ds) {
        var r = '';
        ds.forEach(function (t) { var v = lay(t); if (!r && v && !/^(custom\b|one colou?r|two colou?rs|request custom)/i.test(v)) r = v; });
        return r;
      }
      function mm(v) { return String(v || '').replace(/\s*mm\s*$/i, '').replace(',', '.').trim(); }
      function noi(ds) { var r = []; ds.forEach(function (x) { if (x && r.indexOf(x) < 0) r.push(x); }); return r.join(' - '); }
      var ra1 = [];
      function dat(t, v) { if (v) ra1.push([t, v]); }

      dat('Style', lay('Style of Strap'));
      /* 08/10 (chu shop, muc 7): so do kieu cat — MOT dong ngay sau Style; tick anh -> "size from photo" */
      var kieuCat = lay('Style of Strap'), cW = mm(lay('Cut W')), cD = mm(lay('Cut D')), cK = mm(lay('Cut K')), cAnh = lay('Cut From Photo');
      if (/middle cut/i.test(kieuCat)) dat('Middle Cut', cAnh ? 'size from photo' : (cW && cD ? 'W ' + cW + ' / D ' + cD + ' mm' : ''));
      else if (/wing cut/i.test(kieuCat)) dat('Wing Cut', cAnh ? 'size from photo' : (cW && cD && cK ? 'W ' + cW + ' / D ' + cD + ' / K ' + cK + ' mm' : ''));
      lay('Skin of Leather');
      var kl = lay('Kind of Leather'), mau = lay('Colour');
      if (kl) dat('Leather', noi([kl, mau])); else dat('Colour', mau);

      var lug = lay('Lug Width'), cLug = mm(lay('Custom Lug Width')), cBk = mm(lay('Custom Buckle Width'));
      var bkw = lay('Buckle Width');   /* 20/10 bespoke Single / Double Folding: o Buckle Width rieng (y template cartier / deployant-clasp) -> 2 dong rieng; trang khac khong co o nay nen khong doi */
      var isPam = /^(Submersible|Radiomir|Luminor|Luminor Due|PAM .+)$/.test(kieuCat);
      var isApw = /^Apple Watch /.test(kieuCat);   /* 23/10: Apple Watch — Size + Lug Width + Thickness rieng nhu PAM; khong bat nham PAM */
      if (isApw) {
        dat('Apple Watch Size', lay('Apple Watch Size'));
        if (lug) dat('Lug Width', mm(lug) + ' mm');
        dat('Adapter', lay('Adapter'));
      } else if (isPam) {
        if (lug) dat('Lug Width', mm(lug) + ' mm');
        if (bkw) dat('Buckle Width', mm(bkw) + ' mm');
      } else if (bkw) {
        if (/^custom/i.test(lug) && cLug) dat('Lug Width (Custom)', cLug + ' mm'); else if (lug) dat('Lug Width', /mm$/i.test(lug) || /^custom/i.test(lug) ? lug : lug + ' mm');
        if (/^custom/i.test(bkw) && cBk) dat('Buckle Width (Custom)', cBk + ' mm'); else dat('Buckle Width', /mm$/i.test(bkw) || /^custom/i.test(bkw) ? bkw : bkw + ' mm');
      } else if (/^custom/i.test(lug) && cLug) dat('Lug Width (Custom)', cLug + (cBk ? '/' + cBk : '') + ' mm');
      else if (lug) dat('Lug Width', /mm$/i.test(lug) || /^custom/i.test(lug) ? lug : lug + ' mm');

      var len = lay('Length'), dai = mm(lay('Custom Length Long')), ngan = mm(lay('Custom Length Short')), cLen = lay('Custom Length');
      var ngDai = !!root.querySelector('[data-ngan-dai]');   /* 20/10 Double Folding (y deployant-clasp): bang chon ghi SHORT / LONG -> custom cung thu tu ngan/dai; trang khac khong co thuoc tinh nay */
      if (/^custom/i.test(len) && dai && ngan) dat('Length (Custom)', (ngDai ? ngan + '/' + dai : dai + '/' + ngan) + ' mm');
      else if (/^custom/i.test(len) && cLen) dat('Length (Custom)', cLen);
      else dat('Length', len);
      dat('Wrist Size', lay('Wrist Size'));   /* 08/10 15:26 (chu shop C3): co tay khach go -> dong ngay sau Length */

      var th = lay('Thickness'), cTh = mm(lay('Custom Thickness'));
      if ((!th || /custom|request/i.test(th)) && cTh) th = /^\d+(\.\d+)?$/.test(cTh) ? cTh + ' mm' : cTh;
      if ((isPam || isApw) && cTh && /custom|request/i.test(lay('Thickness'))) th = cTh + ' mm';
      if (isPam || isApw) {
        dat('Form', lay('Strap form'));
        dat('Thickness', th);
        if (isPam) dat('Lug Bar', lay('Lug Bar'));
      } else dat('Form', noi([lay('Strap form'), th]));

      var es = lay('End Shape').replace(/\s*\(as pictured\)\s*$/i, '');
      dat('End Shape', /^curved/i.test(es) ? 'Curved' : /^straight/i.test(es) ? 'Straight' : es);
      dat('Tip Shape', lay('Tip Shape'));

      var ss = chon(['Style of Stitches', 'Stitch Style']);
      if (/double/i.test(ss)) ss = 'Double stitch'; else if (/single/i.test(ss)) ss = 'Single stitch';
      /* 08/10 12:35: Stitch = "Match underlay colour" -> mau chi THAT (cstrap-rally.js ghi vao data-chi-that: dung ten lot / chi gan nhat) */
      var chiThat = chon(['Thread Colour', 'Stitch Colour']);
      if (/^as pictured$/i.test(chiThat)) chiThat = (CFG && CFG.chiAnh) || '';   /* 21:55: bo chu "As Pictured" — mau chi that (builder2d.stitch_colour) */
      if (/^match underlay/i.test(chiThat)) { var gChi = form && form.querySelector('select[id$="-stitch-colour"]'); chiThat = (gChi && gChi.dataset.chiThat) || lotThat || chiThat; }
      dat('Stitching', noi([ss, chiThat]));
      /* 08/10 (chu shop, L10): Edge = "Match underlay colour" -> gio / tom tat ghi MAU LOT THAT ("Edge: Orange") */
      var lotThat = chon(['Custom Underlay Colour', 'Underlay Colour']), vienThat = chon(['Custom Edge Colour', 'Edge colour', 'Edge Colour']);
      if (/^match underlay/i.test(vienThat) && lotThat) vienThat = lotThat;
      dat('Edge', vienThat);
      dat('Underlay', lotThat);

      var kt = lay('Keeper Top'), kb = lay('Keeper Bottom');
      if (kt || kb) dat('Keeper', kt && kb && kt !== kb ? kb + ' (fixed) / ' + kt + ' (floating)' : (kb || kt));
      else dat('Keeper', chon(['Custom Keeper Colour', 'Keeper Colour']));
      lay('Custom Keeper 2 Colour');

      var lot = lay('Lining Leather').split(' ')[0], lotMau = lay('Lining Colour'), zl = lay('Zermatt Lining');
      dat('Lining', noi([lot, lotMau || zl]));

      dat('Buckle', lay('Buckle Finish').replace(/\s+—\s+/g, ' '));
      var bt = lay('Buckle Type');
      if (bt && !/^standard$/i.test(bt)) dat('Buckle Type', bt);
      dat('Spring bar', lay('Spring bar'));

      var CUOI = ['Watch Photo', 'Watch Photo 1', 'Watch Photo 2', 'Watch Photo 3', 'Needs review', 'Engraving', 'Note'];   /* 08/10 15:26: Wrist Size da dat sau Length */
      function day(t) {
        (pr[t] || []).forEach(function (v) { if (typeof v === 'string') ra.append('properties[' + t + ']', v); else ra.append('properties[' + t + ']', v, v.name); });
        da[t] = 1;
      }
      ra2.forEach(function (x) { ra.append(x[0], x[1]); });
      thuTu.forEach(function (t) { if (t.charAt(0) === '_') day(t); });
      ra1.forEach(function (x) { ra.append('properties[' + x[0] + ']', x[1]); });
      thuTu.forEach(function (t) { if (!da[t] && CUOI.indexOf(t) < 0) day(t); });
      CUOI.forEach(function (t) { if (pr[t]) day(t); });
      return ra;
    }
    function xepThuTuProps(fd) {
      var THU_TU = ['Style of Strap', 'Skin of Leather', 'Kind of Leather', 'Colour', 'Curved End', 'End Shape', 'Strap form', 'Thickness', 'Custom Thickness', 'Apple Watch Size', 'Lug Width', 'Adapter', 'Custom Lug Width', 'Buckle Width', 'Custom Buckle Width', 'Length', 'Custom Length', 'Lining Leather', 'Lining Colour', 'Zermatt Lining', 'Tip Shape', 'Stitch Style', 'Style of Stitches', 'Stitch Colour', 'Thread Colour', 'Underlay Colour', 'Custom Underlay Colour', 'Edge colour', 'Custom Edge Colour', 'Keeper Colour', 'Keeper Top', 'Keeper Bottom', 'Custom Keeper Colour', 'Custom Keeper 2 Colour', 'Buckle Finish', 'Buckle Type', 'Spring bar', 'Watch Photo 1', 'Watch Photo 2', 'Watch Photo 3', 'Watch Photo', 'Needs review'];
      var DUOI = ['Engraving', 'Note', 'Wrist Size'];
      var ra = new FormData(), pr = {}, gap = [], xong = {};
      fd.forEach(function (v, k) {
        var m = /^properties\[(.*)\]$/.exec(k);
        if (!m) { ra.append(k, v); return; }
        var ten = m[1];
        var rong = typeof v === 'string' ? !v.trim() : !(v && v.size);
        if (rong && ten !== '_Pricing') return;
        (pr[ten] = pr[ten] || []).push(v);
        if (gap.indexOf(ten) < 0) gap.push(ten);
      });
      function day(ten) {
        if (!pr[ten] || xong[ten]) return;
        xong[ten] = 1;
        pr[ten].forEach(function (v) { if (typeof v === 'string') ra.append('properties[' + ten + ']', v); else ra.append('properties[' + ten + ']', v, v.name); });
      }
      day('_Pricing');
      THU_TU.forEach(day);
      gap.forEach(function (t) { if (DUOI.indexOf(t) < 0) day(t); });
      DUOI.forEach(day);
      return ra;
    }

      /* 07/10: khung tom tat khop gio dung CHINH chuoi nay (mot nguon voi luc gui gio). */
      gomProps = function () { return gonProps(xepThuTuProps(doiKeeper(new FormData(form), form)), form); };
      if (GIO) updateSummary();

      form.addEventListener('submit', function (e) {
        flushVariant();
        flushSummary();   /* 10/10 P4: khung tom tat khong bao gio cu luc gui (property van lay thang tu form) */
        /* 08/10 (chu shop, muc 6): dang gui gio -> bo qua lan bam / submit tiep theo (cham dup tren iPhone ra 2 cai) */
        if (window.CSTRAP_ATC && CSTRAP_ATC.dangGui()) { e.preventDefault(); return; }
        var missing = findMissing();
        if (missing.length) {
          e.preventDefault();
          showErrors(missing, true);
          return;
        }
        clearErrors();

        /* Everything is chosen, but they have not said they looked at it. */
        if (confirmInput && !confirmInput.checked) {
          e.preventDefault();
          confirmBox.classList.add('is-missing');
          confirmBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }

        /* The curved end needs no special case at submit time any more: it is a variant, so the
           hidden id the form already posts is the whole of it. This used to be a two-request dance
           that added a separate $15 product after the strap landed in the cart. */
        syncVariant();
        /* Thang gia: tong khong co bien the -> khong gui gi ca (nut da khoa, day la chan phim Enter). */
        if (LADDER && !pickVariant()) {
          e.preventDefault();
          khoaNutGia(ladderTotal());
          return;
        }

        /*
          A plain form POST reloads the page onto /cart, and the drawer never gets a chance to exist.
          So the add is done in the background and the drawer is handed the freshly rendered markup
          Shopify returns for it — the customer stays on the strap they just designed, with a dozen
          answered questions still on screen behind the panel.

          The `sections` parameter is what makes this one request rather than two: the cart API can
          re-render the drawer and the header count itself, so there is no second round trip and no
          moment where the bubble says 0 while the drawer says 1.

          No drawer on the page — the shop switched the cart back to a page or a notification — and
          this whole branch is skipped, leaving the ordinary form POST to do what it always did.
        */
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;

        e.preventDefault();

        var addBtn = form.querySelector('[type="submit"]');
        if (addBtn) addBtn.setAttribute('aria-disabled', 'true');

        var fd = gonProps(xepThuTuProps(doiKeeper(new FormData(form), form)), form);   /* 03/10: bo o rong; 07/10: dung lai bo property gon (gonProps) */
        if (window.CSTRAP_ATC && !CSTRAP_ATC.batDau(form, fd)) return;   /* 08/10 muc 6: khoa NGAY nut chinh + thanh dinh; cung bo property trong 5 s -> khong gui */
        fd.append(
          'sections',
          drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
        );
        fd.append('sections_url', window.location.pathname);

        fetch('/cart/add', { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state.status) throw new Error(state.description || state.message);
            drawer.classList.remove('is-empty');
            drawer.renderContents(state);
            if (window.CSTRAP_ATC) CSTRAP_ATC.xong(form, true);   /* 08/10 muc 6: "Added ✓" roi mo khoa */
            /* 29/09: bao cho openai-pixel-events.js biet Shopify DA nhan hang. Dat SAU cho kiem
               state.status nen chi chay khi them that su thanh cong. Form nay khong boc
               <product-form> nen khong co PUB_SUB_EVENTS.cartUpdate de nghe. */
            try { document.dispatchEvent(new CustomEvent('xilugs:cart-added', { detail: state })); }
            catch (e) { console.warn('cstrap: xilugs:cart-added', e); }
          })
          .catch(function (err) {
            /* 08/10 (chu shop, muc 6): loi mang / loi Shopify -> mo khoa ngay, bao loi duoi nut, KHONG tu gui lai
               (gui lai la nguon dong trung). Khong co module -> giu cach cu (tra ve trinh duyet gui thuong). */
            if (window.CSTRAP_ATC) { CSTRAP_ATC.xong(form, false, err && err.message ? 'Couldn\u2019t add to cart: ' + err.message : ''); return; }
            /* Never strand the customer on a page that swallowed their order: hand it back to the
               browser, which submits the ordinary way and lands them on /cart. */
            form.submit();
          })
          .finally(function () {
            if (addBtn) addBtn.removeAttribute('aria-disabled');
          });
      });

      if (confirmInput) {
        confirmInput.addEventListener('change', function () {
          if (confirmInput.checked) confirmBox.classList.remove('is-missing');
        });
      }

      /* Once the box is up, keep it in step as the customer fills things in — but never scroll:
         the viewport stays exactly where the customer is picking options. */
      form.addEventListener('change', function () {
        if (!root.querySelector('.cfield.has-error')) return;   /* 02/10: khung khong con hien — theo vien do */
        var missing = findMissing();
        if (missing.length) showErrors(missing, false);
        else clearErrors();
      });
    }

    /* 02/10 (chu shop): V1 — nut them gio doi chu "Choose <muc thieu>" khi con thieu (giong V2), du thi tra chu goc. */
    (function () {
      var nutChinh = form && (form.querySelector('.cstrap__add') || form.querySelector('[type="submit"]'));
      if (!nutChinh || root.cstrapMua) return;
      var chuGoc = nutChinh.textContent.replace(/\s+/g, ' ').trim();
      function veNut() {
        /* 11/10 (QA #2 loi 1): bindPalette dat required cho o dau bang Keeper luc doi cong ("One colour"), cho bang `clear` (rAF) go di — veNut o setTimeout 0 doc duoc
           required TAM THOI -> nut nhay "CHOOSE KEEPER COLOUR - BOTH LOOPS". Go required cua bang Keeper ngay tai day (cung viec cua `clear`, idempotent) -> khong khung nao hien chu sai. */
        var kbox = document.getElementById('ckeeper-custom-' + SID + '');
        if (kbox) { var krs = kbox.querySelectorAll('input[type="radio"]'); for (var ki = 0; ki < krs.length; ki++) if (krs[ki].required) krs[ki].required = false; }
        var ds = findMissing();
        if (!ds.length) { nutChinh.textContent = chuGoc; nutChinh.classList.remove('is-thieu'); return; }   /* 22:30: nut khong kem gia */
        var ten = String(ds[0].label || '').replace(/\s*\(.*$/, '').toLowerCase();
        nutChinh.textContent = 'Choose ' + (ten || 'option');
        nutChinh.classList.add('is-thieu');
      }
      root.addEventListener('change', function () { setTimeout(veNut, 0); });
      root.addEventListener('input', function () { setTimeout(veNut, 0); });
      root.addEventListener('cstrap:tong', function () { setTimeout(veNut, 0); });
      setTimeout(veNut, 0);
    })();

    syncAllHints();
    updateSummary();

    var SW_ITEM = '.cswatch, .ccolor, .cshape';
    var SW_GRID = '.cswatch-grid, .ccolor-grid, .cshape-grid';

    function collectGroup(grid) {
      return Array.prototype.map.call(grid.querySelectorAll(SW_ITEM), function (item) {
        return {
          vis: item.querySelector('.sw-img') || item.querySelector('.ccolor__tile') || item.querySelector('.cshape__svg'),
          name: (item.getAttribute('title') || '').trim()
        };
      });
    }

    function renderZoom() {
      var it = zItems[zIndex];
      if (!it) return;
      stage.innerHTML = '';
      if (it.vis) {
        var clone = it.vis.cloneNode(true);
        /* The thumbnail only loaded a small rendition. Swap in the full-size one,
           otherwise the browser just upscales the thumb and it looks soft. */
        /* Nut kinh lup nam BEN TRONG .cshape__svg (ban snippet tren live), nen no theo
           ca clone vao khung phong to — thanh ra o anh da phong to van hien mot nut "phong to"
           nua, bam khong lam gi. Chu shop bao 2026-09-07. Go han khoi clone thay vi an bang
           CSS: nut an bang display:none van con trong luong tab cua ban phim. */
        clone.querySelectorAll('.sw-zoom').forEach(function (b) { b.remove(); });
        clone.querySelectorAll('img[data-zoom-src]').forEach(function (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.removeAttribute('loading');
          img.removeAttribute('width');
          img.removeAttribute('height');
          img.src = img.getAttribute('data-zoom-src');
        });
        stage.appendChild(clone);
      }
      nameEl.textContent = it.name;
      counter.textContent = (zIndex + 1) + ' / ' + zItems.length;
      var many = zItems.length > 1;
      prevBtn.hidden = !many;
      nextBtn.hidden = !many;
    }

    function step(d) {
      if (!zItems.length) return;
      zIndex = (zIndex + d + zItems.length) % zItems.length;
      renderZoom();
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.sw-zoom');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var item = btn.closest(SW_ITEM);
      var grid = btn.closest(SW_GRID);
      if (!grid || !item) return;
      zItems = collectGroup(grid);
      zIndex = Array.prototype.indexOf.call(grid.querySelectorAll(SW_ITEM), item);
      if (zIndex < 0) zIndex = 0;
      renderZoom();
      openModal(lb);
    });

    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });

    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target === stage || e.target.closest('.cswatch-lb__close')) closeModal(lb);
    });

    /* Size guides. Each field opens only its own guide — lug width shows the width
       chart, length shows the wrist chart — so nobody has to hunt through a
       combined poster on a phone. */
    var sg = document.getElementById('sguide-lb-' + SID + '');
    var sgArt = sg ? sg.querySelector('.sguide-lb__art') : null;

    if (sg && sgArt) {
      /* Not just images any more: the lug guide is a text panel, the length guide is
         still a poster. Both carry data-guide, so select on that. */
      var sgViews = sgArt.querySelectorAll('[data-guide]');

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.sguide-open');
        if (!btn) return;
        e.preventDefault();
        /* Stops the help-modal listener further down, which is bound to this same
           element and would otherwise still run after us. */
        e.stopImmediatePropagation();

        var key = btn.getAttribute('data-guide');
        var found = false, isPanel = false;
        sgViews.forEach(function (el) {
          var mine = el.getAttribute('data-guide') === key;
          el.hidden = !mine;
          if (mine) { found = true; isPanel = el.classList.contains('sguide-panel'); }
        });
        if (!found) return;

        /* A text panel is read, not zoomed: it sizes itself to the box, so the box
           narrows to a comfortable measure and the "tap to zoom" hint stays away. */
        sg.classList.toggle('is-panel', isPanel);
        sg.classList.remove('is-zoomed');
        openModal(sg);
      });

      sg.addEventListener('click', function (e) {
        if (e.target.closest('.sguide-img')) {
          /* Tap the guide to toggle a zoomed, pannable view */
          sg.classList.toggle('is-zoomed');
          return;
        }
        if (e.target === sg || e.target.closest('.sguide-lb__close')) closeModal(sg);
      });
    }

    /* The help ("?") modals still keep their pictures in a <template>, and a browser
       does not fetch those until they are cloned into the document. Pull the bytes in
       once the page has settled, so opening one is instant. The size guides no longer
       need this — their <img> tags are real DOM and load with the page. */
    var warmed = {};
    function warmTemplate(tpl) {
      if (!tpl) return;
      tpl.content.querySelectorAll('img[src]').forEach(function (im) {
        var src = im.getAttribute('src');
        if (!src || warmed[src]) return;
        warmed[src] = true;
        var pre = new Image();
        pre.src = src;
      });
    }

    function warmAllModalArt() {
      root.querySelectorAll('.chelp[data-help-art]').forEach(function (b) {
        warmTemplate(document.getElementById('chelp-art-' + b.getAttribute('data-help-art') + '-' + SID + ''));
      });
    }

    var daWarmArt = false;
    function warmKhiCham() {
      if (daWarmArt) return;
      daWarmArt = true;
      warmAllModalArt();
    }
    (function () {
      var moi = { once: true, passive: true };
      root.querySelectorAll('.chelp').forEach(function (b) {
        b.addEventListener('pointerenter', warmKhiCham, moi);
        b.addEventListener('pointerdown', warmKhiCham, moi);
        b.addEventListener('focus', warmKhiCham, moi);
      });
    })();

    /* "?" help modal */
    var hp = document.getElementById('chelp-lb-' + SID + '');
    if (hp) {
      var hpTitle = hp.querySelector('.chelp-lb__title');
      var hpText = hp.querySelector('.chelp-lb__text');

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.chelp');
        /* The size-guide links carry .chelp too, purely to borrow its styling. Without
           this guard they matched here as well, and opened the help dialog — with no
           title, no text and no picture — as a blank white sheet directly on top of the
           guide. That is the "white box until you press X" bug: X dismissed the empty
           help sheet and revealed the guide that had been underneath it all along.
           Both listeners sit on `root`, so stopPropagation() cannot separate them. */
        if (!btn || btn.classList.contains('sguide-open')) return;
        e.preventDefault();
        e.stopPropagation();
        hpTitle.textContent = btn.getAttribute('data-help-title') || '';

        /*
          The help copy is written with **stars** around the phrases that carry the decision, and they
          are turned into <strong> here — by building the nodes, never by assigning innerHTML. That
          distinction is the whole point: the text stays data, so a stray angle bracket in a merchant's
          copy is printed, not parsed. A wall of undifferentiated prose in a modal gets skimmed and the
          one sentence that would have prevented a wrong order is the one that gets skipped.
        */
        hpText.textContent = '';
        var parts = (btn.getAttribute('data-help-text') || '').split('**');
        parts.forEach(function (chunk, i) {
          if (!chunk) return;
          var node = i % 2 ? document.createElement('strong') : document.createTextNode(chunk);
          if (i % 2) node.textContent = chunk;
          hpText.appendChild(node);
        });

        /* optional illustration: a real photo if one was supplied, else a drawn <template> */
        var art = hp.querySelector('.chelp-lb__art');
        art.innerHTML = '';

        var imgSrc = btn.getAttribute('data-help-img');
        if (imgSrc) {
          var fig = document.createElement('figure');
          /* 08/10 (chu shop 14:48): MOT khung cho moi popup — bo ngoai le data-help-full; o anh 16:10 o cstrap-popup.css */
          fig.className = 'cend';
          var im = document.createElement('img');
          im.src = imgSrc;
          im.alt = btn.getAttribute('data-help-title') || '';
          im.loading = 'eager';
          im.decoding = 'async';
          fig.appendChild(im);
          art.appendChild(fig);
        } else {
          var artKey = btn.getAttribute('data-help-art');
          if (artKey) {
            var tpl = document.getElementById('chelp-art-' + artKey + '-' + SID + '');
            if (tpl) art.appendChild(tpl.content.cloneNode(true));
          }
        }

        openModal(hp);
      });

      hp.addEventListener('click', function (e) {
        if (e.target === hp || e.target.closest('.chelp-lb__close')) closeModal(hp);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!lb.hidden) {
        if (e.key === 'ArrowLeft') { step(-1); return; }
        if (e.key === 'ArrowRight') { step(1); return; }
      }
      if (e.key !== 'Escape') return;
      closeModal(lb);
      if (sg) { sg.classList.remove('is-zoomed'); closeModal(sg); }
      if (hp) closeModal(hp);
    });
  }

(function () {
  var ds = document.querySelectorAll('script[type="application/json"][data-cstrap-cfg]');
  for (var i = 0; i < ds.length; i++) {
    var cfg;
    try { cfg = JSON.parse(ds[i].textContent); } catch (e) { continue; }
    if (!cfg || !cfg.sid) continue;
    try { cstrapKhoiTao(String(cfg.sid), cfg); } catch (e) {
      if (window.console) console.error('cstrap-engine:', e);
    }
  }
})();

/* 11/10 DOT 2 (chu shop): khung mau rieng (PC cuon doc, mobile 2 hang vuot ngang) TU CUON toi o dang chon khi mo trang, doi loai da,
   doi cua so (PC <-> mobile doi huong cuon). Chi cuon BEN TRONG khung (scrollLeft/scrollTop cua luoi), khong cuon trang; khach tu bam o thi khong cuon. */
(function () {
  var timer = 0;
  function hien(g) {
    if (!g.offsetParent) return;
    var inp = g.querySelector('.ccolor input:checked'); if (!inp) return;
    var c = inp.closest('.ccolor'); if (!c) return;
    var gr = g.getBoundingClientRect(), cr = c.getBoundingClientRect(), cs = window.getComputedStyle(g);
    if (g.scrollWidth > g.clientWidth + 4 && cs.overflowX !== 'visible') {
      /* canh theo MEP COT: cot truoc (cach 1 khe) khong con lo ra trong dem khung */
      var khe = parseFloat(cs.columnGap) || 0, vien = parseFloat(cs.borderLeftWidth) || 0, dem = parseFloat(cs.paddingLeft) || 0;
      if (cr.left < gr.left + vien + dem - 1 || cr.right > gr.right - 12) g.scrollLeft = Math.max(0, g.scrollLeft + cr.left - gr.left - vien - khe);
    } else if (g.scrollHeight > g.clientHeight + 4 && cs.overflowY !== 'visible') {
      if (cr.top < gr.top || cr.bottom > gr.bottom) g.scrollTop += cr.top - gr.top - 30;
    }
  }
  /* PC (>= 750): moi luoi mau / chip tu 4 hang tro len dong khung cao THEO CAO HANG THAT: 2 hang day du + NUA TREN o anh hang 3 (cat giua anh, khong cat qua chu),
     phan con lai cuon trong khung. Chi dat bien --cg-max (CSS: max-height: var(--cg-max, 360px)); luoi <= 3 hang de nguyen. Mobile: bo bien. */
  function vua(g) {
    if (!g.offsetParent) return;
    var pc = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    var v = '';
    if (pc) {
      var gr = g.getBoundingClientRect(), hang = [], k = g.children;
      for (var i = 0; i < k.length; i++) {
        var r = k[i].getBoundingClientRect(); if (r.height < 1) continue;
        var top = Math.round(r.top - gr.top + g.scrollTop), h = hang[hang.length - 1];
        var tl = k[i].querySelector('.ccolor__tile, .sw-img'), th = tl ? tl.getBoundingClientRect().height : r.width;
        if (!h || Math.abs(h.top - top) > 2) hang.push({ top: top, h: r.height, t: th }); else if (th > h.t) h.t = th;
      }
      var _exact3 = g.classList.contains('ccolor-grid--tiles') || !!g.closest('[id^="cstitch-custom-"]');   /* 13/10: o phang / chi = 3 hang TRON + dem day 5px; o da = 2,5 hang */
      v = hang.length < 4 ? 'none' : (_exact3 ? Math.round(hang[2].top + hang[2].h + 5) : Math.round(hang[2].top + hang[2].t * 0.5)) + 'px';   /* cat o GIUA ANH hang 3 (2 hang day du + nua tren o), khong bao gio cat qua chu ten */
    }
    if (v) { if (g.style.getPropertyValue('--cg-max') !== v) g.style.setProperty('--cg-max', v); }
    else if (g.style.getPropertyValue('--cg-max')) g.style.removeProperty('--cg-max');
  }
  var ro = window.ResizeObserver ? new ResizeObserver(function (es) { for (var i = 0; i < es.length; i++) vua(es[i].target); }) : null;
  function soi() {
    var gs = document.querySelectorAll('.cstrap-section .ccolor-grid');
    for (var i = 0; i < gs.length; i++) { if (ro && !gs[i].__vua) { gs[i].__vua = 1; ro.observe(gs[i]); } vua(gs[i]); }
    return gs;
  }
  function tatCa() { var gs = soi(); for (var j = 0; j < gs.length; j++) hien(gs[j]); }
  function hen(ms) { clearTimeout(timer); timer = setTimeout(tatCa, ms); }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest || !t.closest('.cstrap-section')) return;
    if (t.closest('.ccolor-grid')) return;
    hen(250);
  });
  window.addEventListener('resize', function () { hen(200); });
  if (window.MutationObserver) { var moT = 0, mo = new MutationObserver(function () { clearTimeout(moT); moT = setTimeout(soi, 120); }); document.querySelectorAll('.cstrap-section').forEach(function (n) { mo.observe(n, { childList: true, subtree: true }); }); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { hen(100); });
  window.addEventListener('pageshow', function () { hen(100); });
  if (document.readyState === 'complete') hen(100); else window.addEventListener('load', function () { hen(300); });
  hen(600);
})();

/* 13/10 vong 10 (chu shop, "ten mau dai thi giam size nhu Moc"): ten duoi MOI o mau 1 dong, khong "...": 12px -> giam 0,5px toi khi vua be ngang hop ten (toi thieu 8,5px). Chay luc tai, khi doi be ngang / bang mau / lua chon. Chi doi font-size inline cua .ccolor__n / .cshape__n lot da. */
(function () {
  if (window.__cstrapNameFit) return; window.__cstrapNameFit = 1;
  var MAX = 12, MIN = 8.5, STEP = 0.5, tm = 0;
  function ds() {
    var r = [], a = document.querySelectorAll('.cstrap-section .ccolor__n, .cstrap-section .cshape-grid .cshape__n');
    for (var i = 0; i < a.length; i++) {
      var n = a[i]; if (!n.offsetParent) continue;
      if (n.classList.contains('cshape__n')) { var g = n.closest('.cshape-grid'); if (!g || !g.querySelector('input[name="properties[Lining Colour]"], input[name="properties[Zermatt Lining]"]')) continue; }
      r.push(n);
    }
    return r;
  }
  function fit() {
    tm = 0; var ns = ds(), i, w = [];
    for (i = 0; i < ns.length; i++) { ns[i].style.fontSize = MAX + 'px'; ns[i].style.fontWeight = '500'; }   /* do o do dam 500 (o dang chon) -> chon / bo chon khong bi cat, khong doi co */
    for (i = 0; i < ns.length; i++) w.push([ns[i].clientWidth, ns[i].scrollWidth]);
    for (i = 0; i < ns.length; i++) { var c = w[i][0], s = w[i][1]; if (c && s > c + 0.5) ns[i].style.fontSize = Math.max(MIN, Math.floor(MAX * c / s * 2) / 2) + 'px'; }
    for (i = 0; i < ns.length; i++) { var f = parseFloat(ns[i].style.fontSize); if (f > MIN && ns[i].scrollWidth > ns[i].clientWidth + 0.5) ns[i].style.fontSize = Math.max(MIN, f - STEP) + 'px'; }
    var info = []; for (i = 0; i < ns.length; i++) { info.push([ns[i].textContent.trim(), parseFloat(ns[i].style.fontSize), ns[i].clientWidth, ns[i].scrollWidth]); ns[i].style.fontWeight = ''; }
    window.__cstrapNameFitInfo = info;
  }
  function lich(ms) { if (tm) clearTimeout(tm); tm = setTimeout(fit, ms == null ? 150 : ms); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { lich(0); }); else lich(0);
  window.addEventListener('load', function () { lich(100); });
  window.addEventListener('resize', function () { lich(200); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { lich(0); });
  ['change', 'click'].forEach(function (ev) { document.addEventListener(ev, function () { lich(250); }, true); });
  if (window.MutationObserver) new MutationObserver(function () { lich(200); }).observe(document.body, { childList: true, subtree: true });
})();

/* 13/10 (B5): dem ky tu o Note "n of 500" (maxlength 500 co san). */
(function () {
  if (window.__cstrapNoteCount) return; window.__cstrapNoteCount = 1;
  function dung() {
    var ta = document.querySelector('.cstrap-section textarea[name="properties[Note]"]'); if (!ta || ta.__dem) return;
    ta.__dem = 1; var mx = ta.maxLength > 0 ? ta.maxLength : 500;
    var c = document.createElement('span'); c.className = 'cnote__count'; c.setAttribute('aria-hidden', 'true');
    function ghi() { c.textContent = ta.value.length + ' of ' + mx; }
    ta.insertAdjacentElement('afterend', c); ghi(); ta.addEventListener('input', ghi); ta.addEventListener('change', ghi);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dung); else dung();
  setTimeout(dung, 1500);
})();
